(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-accessories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nano-accessories')) {
    customElements.define('nano-accessories', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const signal = this.events.signal;
        this.observer = new ResizeObserver(() => this.updateRails());
        this.querySelectorAll('.accessory-rail').forEach(rail => {
          const controls = rail.nextElementSibling;
          if (!controls?.classList.contains('accessory-rail-controls')) return;
          rail.addEventListener('scroll', () => this.updateRail(rail), { passive:true, signal });
          controls.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
            const rtl = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
            rail.scrollBy({ left:Number(button.dataset.direction) * rail.clientWidth * rtl, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }, { signal }));
          this.observer.observe(rail);
        });
        this.updateRails();
      }
      updateRail(rail) {
        const controls = rail.nextElementSibling;
        if (!controls?.classList.contains('accessory-rail-controls')) return;
        const maximum = rail.scrollWidth - rail.clientWidth;
        controls.hidden = maximum <= 2;
        controls.querySelector('[data-direction="-1"]').disabled = Math.abs(rail.scrollLeft) <= 2;
        controls.querySelector('[data-direction="1"]').disabled = Math.abs(rail.scrollLeft) >= maximum - 2;
      }
      updateRails() { this.querySelectorAll('.accessory-rail').forEach(rail => this.updateRail(rail)); }
      disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-airtag-preview-collection"] && !Shopify.designMode) return;
  try {
    
class NanoCollectionBrowser extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    const signal = this.events.signal;
    const dialog = this.querySelector('dialog');
    const opener = this.querySelector('#filter-open');
    opener?.addEventListener('click', () => dialog.showModal(), {signal});
    this.querySelector('[data-close-filters]')?.addEventListener('click', () => dialog.close(), {signal});
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, {signal});
    dialog?.addEventListener('close', () => opener.focus({preventScroll:true}), {signal});
    this.querySelector('#sort-select')?.addEventListener('change', event => event.target.form.requestSubmit(), {signal});
    const nav = this.querySelector('.material-navigation');
    const rail = nav?.querySelector('.material-navigation__rail');
    if (!rail) return;
    const controls = nav.querySelector('.material-navigation__controls');
    const previous = controls.querySelector('button:first-child');
    const next = controls.querySelector('button:last-child');
    const desktop = matchMedia('(min-width:701px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const behavior = () => reduced.matches ? 'instant' : 'smooth';
    const update = () => {
      controls.hidden = !desktop.matches || rail.scrollWidth <= nav.clientWidth + 1;
      previous.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
    };
    const reveal = link => {
      const item = link.getBoundingClientRect();
      const view = rail.getBoundingClientRect();
      if (item.left < view.left || item.right > view.right) rail.scrollBy({left:item.left < view.left ? item.left-view.left : item.right-view.right,behavior:behavior()});
    };
    previous.addEventListener('click', () => rail.scrollBy({left:-rail.clientWidth*.75,behavior:behavior()}), {signal});
    next.addEventListener('click', () => rail.scrollBy({left:rail.clientWidth*.75,behavior:behavior()}), {signal});
    rail.addEventListener('scroll', update, {passive:true,signal});
    rail.addEventListener('focusin', event => {const link=event.target.closest('a');if(link)reveal(link);}, {signal});
    let gesture;
    let suppressUntil = 0;
    rail.addEventListener('pointerdown', event => {suppressUntil=0;gesture={id:event.pointerId,x:event.clientX,y:event.clientY,scroll:rail.scrollLeft,moved:false};}, {passive:true,signal});
    rail.addEventListener('pointermove', event => {if(gesture?.id===event.pointerId&&Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>8)gesture.moved=true;}, {passive:true,signal});
    const finish = event => {if(gesture?.id!==event.pointerId)return;if(gesture.moved||Math.abs(rail.scrollLeft-gesture.scroll)>8||event.type==='pointercancel')suppressUntil=performance.now()+700;gesture=null;};
    rail.addEventListener('pointerup',finish,{passive:true,signal});
    rail.addEventListener('pointercancel',finish,{passive:true,signal});
    rail.addEventListener('click',event=>{if(event.detail!==0&&performance.now()<suppressUntil)event.preventDefault();},{capture:true,signal});
    desktop.addEventListener('change',update,{signal});
    this.observer = new ResizeObserver(update);
    this.observer.observe(nav);
    this.observer.observe(rail);
    update();
    document.fonts.ready.then(()=>{if(!this.isConnected)return;update();const selected=rail.querySelector('[aria-current="page"]');if(selected)reveal(selected);});
  }
  disconnectedCallback() {this.events?.abort();this.observer?.disconnect();}
}
if (!customElements.get('nano-collection-browser')) customElements.define('nano-collection-browser',NanoCollectionBrowser);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-article"]) return;
  try {
    
  if (!customElements.get('nano-article')) {
    customElements.define('nano-article', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const prose = this.querySelector('.na-prose');
        const walker = document.createTreeWalker(prose, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) walker.currentNode.textContent = walker.currentNode.textContent.replaceAll('™', '');
        prose.querySelectorAll('meta').forEach(node => node.remove());
        const splitLines = element => {
          const lines = [document.createDocumentFragment()];
          for (const node of Array.from(element.childNodes)) {
            if (node.nodeName === 'BR') lines.push(document.createDocumentFragment());
            else if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('br')) {
              const fragments = splitLines(node);
              fragments.forEach((fragment, index) => {
                if (index) lines.push(document.createDocumentFragment());
                const clone = node.cloneNode(false);
                clone.append(fragment);
                lines[lines.length - 1].append(clone);
              });
            } else lines[lines.length - 1].append(node.cloneNode(true));
          }
          return lines;
        };
        const flushInline = nodes => {
          if (!nodes.length) return;
          const p = document.createElement('p');
          nodes[0].before(p);
          nodes.forEach(node => p.append(node));
          nodes.length = 0;
        };
        const inline = [];
        for (const node of Array.from(prose.childNodes)) {
          if (node.nodeType === Node.ELEMENT_NODE && /^(P|H[1-6]|UL|OL|TABLE|DIV|BLOCKQUOTE|FIGURE|HR)$/.test(node.nodeName)) flushInline(inline);
          else inline.push(node);
        }
        flushInline(inline);
        prose.querySelectorAll(':scope > p').forEach(p => {
          const fragments = splitLines(p);
          if (fragments.length < 2) return;
          const output = document.createDocumentFragment();
          fragments.forEach(fragment => {
            if (!fragment.textContent.trim() && !fragment.querySelector('img')) return;
            const line = document.createElement('p');
            line.append(fragment);
            output.append(line);
          });
          p.replaceWith(output);
        });
        prose.querySelectorAll(':scope > p').forEach(p => {
          const text = p.textContent.trim();
          if (!text && !p.querySelector('img')) { p.remove(); return; }
          const copy = p.cloneNode(true);
          copy.querySelectorAll('strong,b').forEach(node => node.remove());
          if (text.length && text.length < 180 && !copy.textContent.trim() && !/[.!]$/.test(text) && !/^[-•]\s/.test(text)) {
            const heading = document.createElement('h2');
            heading.append(...p.childNodes);
            p.replaceWith(heading);
          }
        });
        prose.querySelectorAll('h1').forEach(node => {
          const heading = document.createElement('h2');
          heading.append(...node.childNodes);
          node.replaceWith(heading);
        });
        const normalise = value => value.toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
        const first = prose.firstElementChild;
        if (first && /^H[1-6]$/.test(first.nodeName) && normalise(first.textContent) === normalise(this.querySelector('h1').textContent)) first.remove();
        prose.querySelectorAll('h2,h3,h4').forEach(heading => {
          const text = heading.textContent;
          if (text !== text.toUpperCase() || !/[A-Z]/.test(text)) return;
          const nodes = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
          let started = false;
          while (nodes.nextNode()) {
            let value = nodes.currentNode.textContent.toLowerCase().replace(/\b(nano|rfid|edc|uk|chic|3k|id)\b/g, word => word.toUpperCase()).replace(/\bairtag\b/g, 'AirTag');
            if (!started && /[a-zA-Z]/.test(value)) { value = value.replace(/[a-zA-Z]/, letter => letter.toUpperCase()); started = true; }
            nodes.currentNode.textContent = value;
          }
        });
        let list;
        for (const node of Array.from(prose.children)) {
          if (node.nodeName === 'P' && /^\s*[-•]\s/.test(node.textContent)) {
            if (!list) { list = document.createElement('ul'); node.before(list); }
            const textNodes = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
            while (textNodes.nextNode()) {
              if (textNodes.currentNode.textContent.trim()) { textNodes.currentNode.textContent = textNodes.currentNode.textContent.replace(/^\s*[-•]\s*/, ''); break; }
            }
            const item = document.createElement('li');
            item.append(...node.childNodes);
            list.append(item);
            node.remove();
          } else list = null;
        }
        prose.querySelectorAll('a[href]').forEach(link => {
          if (link.origin === location.origin) link.removeAttribute('target');
          if (link.title) link.title = link.title.replaceAll('™', '');
        });
        const headings = Array.from(prose.querySelectorAll('h2'));
        headings.forEach((heading, index) => { if (!heading.id) heading.id = 'article-section-' + (index + 1); heading.tabIndex = -1; });
        const contents = this.querySelector('.na-contents');
        if (headings.length >= 3) {
          const menu = contents.querySelector('ol');
          headings.forEach(heading => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = '#' + heading.id;
            link.textContent = heading.textContent;
            item.append(link);
            menu.append(item);
          });
          contents.hidden = false;
          this.mediaQuery = matchMedia('(min-width: 991px)');
          this.setContents = () => { contents.open = this.mediaQuery.matches; };
          this.setContents();
          this.mediaQuery.addEventListener('change', this.setContents);
        }
        prose.querySelectorAll('table').forEach((table, index) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'na-table';
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          const previous = Array.from(prose.querySelectorAll('h2,h3')).filter(heading => heading.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
          if (previous) { if (!previous.id) previous.id = 'article-table-title-' + index; wrapper.setAttribute('aria-labelledby', previous.id); }
          else wrapper.setAttribute('aria-label', this.dataset.featureLabel);
          table.before(wrapper);
          wrapper.append(table);
          table.querySelectorAll('thead th').forEach(cell => { cell.scope = 'col'; if (!cell.textContent.trim()) cell.textContent = this.dataset.featureLabel; });
          table.querySelectorAll('tbody tr').forEach(row => {
            const cell = row.firstElementChild;
            if (cell && cell.nodeName === 'TD') { const header = document.createElement('th'); header.scope = 'row'; header.append(...cell.childNodes); cell.replaceWith(header); }
          });
        });
      }
      disconnectedCallback() { if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.setContents); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-bag-personalisation-demo"]) return;
  try {
    
  if (!customElements.get('nano-bag-personalisation-demo')) {
    customElements.define('nano-bag-personalisation-demo', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        const options = { signal:this.controller.signal };
        this.addEventListener('click', event => {
          if (event.target.closest('[data-nbp-open]')) this.open();
          if (event.target.closest('[data-nbp-close]')) this.dialog.close();
          if (event.target.closest('[data-nbp-preview]')) this.querySelector('.nbp-status').textContent = this.dataset.previewMessage;
        }, options);
        this.dialog.addEventListener('close', () => this.unlock(), options);
        this.open();
      }
      open() {
        if (this.dialog.open) return;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        this.dialog.showModal();
        this.querySelector('[data-nbp-close]').focus({ preventScroll:true });
      }
      unlock() {
        if (!this.locked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.unlock();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-bundle-demo-main"]) return;
  try {
    
if (!customElements.get('nano-product-draft2')) {
  customElements.define('nano-product-draft2', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const $ = selector => this.querySelector(selector);
      const $$ = selector => [...this.querySelectorAll(selector)];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduced ? 'instant' : 'smooth';
      const form = $('product-form-component form');
      const inputs = $$('[data-nano-engraving-input]');
      const input = inputs[0];
      const confirm = $('[data-nano-engraving-confirm]');
      const previews = $$('[data-nano-text-preview]');
      const emptyPreviews = new Map(previews.map(preview => [preview, preview.textContent]));
      const mainButton = $('.add-to-bag');
      const sticky = $('.sticky-purchase');
      const stickyButton = $('.sticky-button');
      const track = $('.gallery-track');
      const thumbs = $$('.gallery-thumb');
      const slides = $$('.gallery-slide');
      const zoom = $('#zoom-dialog');
      const gallery = $('.gallery');
      const sizeGallery = () => gallery?.style.setProperty('--nano-gallery-top',`${Math.min(24,innerHeight-gallery.getBoundingClientRect().height-24)}px`);
      this.galleryObserver?.disconnect();
      this.galleryObserver = new ResizeObserver(sizeGallery);
      if(gallery)this.galleryObserver.observe(gallery);
      addEventListener('resize',sizeGallery,options);
      let frame = 0;
      const setGallery = (next, scroll=true) => {
        if (!slides.length) return;
        frame = (next+slides.length)%slides.length;
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed',String(i===frame)));
        $('.gallery-count').textContent = `${String(frame+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
        $('.gallery-caption').textContent=slides[frame].dataset.caption||slides[frame].getAttribute('aria-label');
        if (scroll) track.scrollTo({left:frame*track.clientWidth,behavior});
        if (zoom.open) {
          const photo=slides[frame].querySelector('img');
          $('.zoom-image-container img').src=thumbs[frame].dataset.large;
          $('.zoom-image-container img').alt=photo.alt;
          $('.zoom-caption').textContent=`${$('.gallery-caption').textContent} · ${$('.gallery-count').textContent}`;
          $('.zoom-image-container').classList.remove('is-magnified');
        }
      };
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>setGallery(i),options));
      $('.gallery-previous')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.gallery-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      track?.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.galleryFrame);
        this.galleryFrame=requestAnimationFrame(()=>setGallery(Math.round(track.scrollLeft/track.clientWidth),false));
      },{...options,passive:true});
      track?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();setGallery(event.key==='Home'?0:event.key==='End'?slides.length-1:frame+(event.key==='ArrowRight'?1:-1));
      },options);
      $('.zoom-open')?.addEventListener('click',()=>{zoom.showModal();setGallery(frame,false);},options);
      $('.zoom-prev')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.zoom-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      $('.zoom-image-container')?.addEventListener('click',()=>$('.zoom-image-container').classList.toggle('is-magnified'),options);
      zoom?.querySelector('.close-dialog')?.addEventListener('click',()=>zoom.close(),options);
      zoom?.addEventListener('click',event=>{if(event.target===zoom)zoom.close();},options);
      zoom?.addEventListener('keydown',event=>{
        if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();setGallery(frame+(event.key==='ArrowRight'?1:-1));}
      },options);

      const colours={
        'Phantom Black':'#29282b','Ghost Silver':'#d1d2ce','Forza Grey':'#93a3a9','Heritage Green':'#8d9e70','Riviera Navy':'#34485b','Portofino Red':'#b1333b','Volcano Red':'#ce352b','Ventura Orange':'#c77235','Spectre Gold':'#bcab84','Spyder Grey':'#717578','Titan Gunmetal':'#626568','Sonic Copper':'#a56946','Racing Green':'#2e5146','Skyfall Navy':'#293d59','Carrera White':'#eeeae3','Nebula Purple':'#684766','Viper Green':'#8dba41','Dark Storm':'#35393d','Onyx Eclipse':'#222225','Flame Burnt':'linear-gradient(135deg,#385d90,#a9664e,#99783b)','Velocity Blue':'#2d84b8','Stealth Black':'#262626','Nero':'#262626','Nero/Argento':'linear-gradient(135deg,#292929 45%,#b7b6b0 55%)','Nero/Viola':'linear-gradient(135deg,#292929 45%,#73498b 55%)','Nero/Arancione':'linear-gradient(135deg,#292929 45%,#d5752e 55%)','Nero/Rosso':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Nero/Verde':'linear-gradient(135deg,#292929 45%,#49965a 55%)','Nero/Oro':'linear-gradient(135deg,#292929 45%,#b4a05a 55%)','Nero/Azzuro':'linear-gradient(135deg,#292929 45%,#327cb4 55%)','Diablo Red/Stealth Black':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Ocean Mist':'#bacdd0','Orchard Mint':'#c1ccb6','Sunset Blush':'#d7b3b7','Twilight Lilac':'#b5a7c5'};
      const aluminiumWallet=this.hasAttribute('data-aluminium-wallet');
      const carbonOrder=this.dataset.walletMaterial==='CARBON FIBRE 3K'?["Stealth Black","Diablo Red/Stealth Black","Stealth Black/Nebula Purple","Stealth Black/Ventura Orange","Stealth Black/Volcano Red","Stealth Black/Miami Blue","Stealth Black/Viper Green","Stealth Black/Ghost Silver","Stealth Black/Spectre Gold"]:this.dataset.walletMaterial==='FORGED CARBON'?["Nero","Nero/Argento","Nero/Oro","Nero/Verde","Nero/Azzuro","Nero/Rosso","Nero/Arancione","Nero/Viola"]:null;
      const approvedOrder=carbonOrder||(aluminiumWallet?['Phantom Black','Titan Gunmetal','Forza Grey','Spyder Grey','Ghost Silver','Carrera White','Spectre Gold','Sonic Copper','Racing Green','Heritage Green','Viper Green','Skyfall Navy','Riviera Navy','Velocity Blue','Portofino Red','Volcano Red','Ventura Orange','Nebula Purple','Dark Storm','Onyx Eclipse','Flame Burnt']:['Phantom Black','Ghost Silver','Forza Grey','Heritage Green','Riviera Navy','Portofino Red','Volcano Red','Ventura Orange','Spectre Gold','Spyder Grey']);
      const rank=link=>{const index=approvedOrder.indexOf(link.title);return index<0?approvedOrder.length:index;};
      const swatches=$$('.swatch').sort((a,b)=>rank(a)-rank(b));
      swatches.forEach(link=>$('.swatches').append(link));
      swatches.forEach(link=>link.style.setProperty('--swatch',colours[link.getAttribute('title')]||'#777'));
      if ($('[data-colour-count]')) $('[data-colour-count]').textContent=this.dataset.colourLabel.replace('[count]',swatches.length);
      const colourRail=$('.swatches'),colourNavigation=$('.swatch-navigation'),colourBack=$('.swatch-back'),colourForward=$('.swatch-forward');
      if(colourRail&&colourBack&&colourForward){
        const syncColourArrows=()=>{
          const maximum=colourRail.scrollWidth-colourRail.clientWidth;
          const position=Math.abs(colourRail.scrollLeft);
          const focused=document.activeElement;
          [[colourBack,position<=2],[colourForward,position>=maximum-2]].forEach(([button,unavailable])=>{
            button.disabled=unavailable;
            button.classList.toggle('is-unavailable',unavailable);
          });
          if((focused===colourBack||focused===colourForward)&&(focused.disabled||focused.hidden)){
            const available=[colourBack,colourForward].find(button=>!button.disabled&&!button.hidden);
            (available||$('.swatch[aria-current="page"]')||swatches[0])?.focus({preventScroll:true});
          }
        };
        const sizeColourNavigation=()=>{
          const style=getComputedStyle(colourRail);
          const contentWidth=swatches.reduce((width,swatch)=>width+swatch.getBoundingClientRect().width,0)+Math.max(0,swatches.length-1)*(parseFloat(style.columnGap)||0)+(parseFloat(style.paddingLeft)||0)+(parseFloat(style.paddingRight)||0);
          const overflows=contentWidth>colourNavigation.clientWidth+2;
          colourBack.hidden=!overflows;
          colourForward.hidden=!overflows;
          syncColourArrows();
        };
        const scrollColours=direction=>{
          const sign=getComputedStyle(colourRail).direction==='rtl'?-1:1;
          colourRail.scrollBy({left:direction*sign*colourRail.clientWidth*.8,behavior});
        };
        colourBack.addEventListener('click',()=>scrollColours(-1),options);
        colourForward.addEventListener('click',()=>scrollColours(1),options);
        colourRail.addEventListener('scroll',syncColourArrows,{...options,passive:true});
        this.colourObserver=new ResizeObserver(sizeColourNavigation);
        this.colourObserver.observe(colourNavigation);
        requestAnimationFrame(()=>{
          sizeColourNavigation();
          const selected=$('.swatch[aria-current="page"]');
          colourRail.scrollLeft=0;
          if(selected&&!aluminiumWallet&&!carbonOrder){
            const delta=selected.getBoundingClientRect().right-colourRail.getBoundingClientRect().right;
            if(delta>0)colourRail.scrollLeft=delta+4;
          }
          syncColourArrows();
        });
      }
      $('.swatches')?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();const i=swatches.indexOf(document.activeElement);
        const n=event.key==='Home'?0:event.key==='End'?swatches.length-1:(i+(event.key==='ArrowRight'?1:-1)+swatches.length)%swatches.length;
        swatches[n].focus();
      },options);

      const focusEngraving=()=>{
        if(!input)return;
        const target=inputs.find(field=>!field.validity.valid)||input;
        target.closest('details').open=true;
        target.scrollIntoView({behavior,block:'center'});target.focus({preventScroll:true});
      };
      const syncText=()=>{
        previews.forEach(preview=>{const field=inputs.find(field=>field.name===preview.dataset.nanoTextPreview);preview.textContent=field?.value.trim()?field.value:emptyPreviews.get(preview);});
        updateSticky();
      };
      inputs.forEach(field=>field.addEventListener('input',syncText,options));
      confirm?.addEventListener('change',()=>updateSticky(),options);
      form?.addEventListener('invalid',event=>{const details=event.target.closest('details');if(details)details.open=true;},{...options,capture:true});
      form?.addEventListener('submit',event=>{
        if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
      },{...options,capture:true});
      $('[data-nano-variant]')?.addEventListener('change',event=>{
        const next=new URL(location.href);next.searchParams.set('variant',event.target.value);const quantity=form?.querySelector('[name="quantity"]');if(quantity?.validity.valid)next.searchParams.set('quantity',quantity.value);location.assign(next);
      },options);
      const updateSticky=()=>{
        if(!mainButton||!sticky)return;
        const rect=mainButton.getBoundingClientRect();
        const before=rect.top>innerHeight;
        const activeField=document.activeElement;
        const focusInField=activeField?.matches('textarea, select, input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"])');
        const galleryPassed=$('.gallery-stage').getBoundingClientRect().top<0;
        const footerVisible=this.closest('.nano-draft2').querySelector('footer').getBoundingClientRect().top<innerHeight;
        const show=rect.bottom<0||(matchMedia('(max-width:700px)').matches&&before&&galleryPassed);
        sticky.hidden=!show||focusInField||zoom.open||footerVisible;
        sticky.classList.toggle('is-before',before);
        stickyButton.disabled=mainButton.disabled;
        stickyButton.firstElementChild.textContent=mainButton.disabled?mainButton.firstElementChild.textContent:before?sticky.dataset.chooseLabel:input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)?sticky.dataset.personaliseLabel:sticky.dataset.addLabel;
      };
      stickyButton?.addEventListener('click',()=>{
        if(mainButton.disabled)return;
        if(sticky.classList.contains('is-before')){$('.purchase-options').scrollIntoView({behavior,block:'center'});return;}
        if(input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)){focusEngraving();form.reportValidity();return;}
        form.requestSubmit(mainButton);
      },options);
      addEventListener('scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(updateSticky);},{...options,passive:true});
      addEventListener('resize',updateSticky,options);
      document.addEventListener('focusin',updateSticky,options);
      document.addEventListener('focusout',()=>requestAnimationFrame(updateSticky),options);
      this.buttonObserver=new MutationObserver(updateSticky);if(mainButton)this.buttonObserver.observe(mainButton,{attributes:true,attributeFilter:['disabled']});
      $$('.products-section').forEach(section=>{
        const row=section.querySelector('.product-row');
        section.querySelector('.row-next')?.addEventListener('click',()=>row.scrollBy({left:row.clientWidth*.8,behavior}),options);
        section.querySelector('.row-prev')?.addEventListener('click',()=>row.scrollBy({left:-row.clientWidth*.8,behavior}),options);
        row?.addEventListener('scroll',()=>section.querySelector('.row-controls').classList.toggle('can-go-back',row.scrollLeft>10),{...options,passive:true});
      });
      const wrapper=this.closest('.nano-draft2');
      const pendingKey='nano-product-engraving-transfer';
      try {
        const pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');
        sessionStorage.removeItem(pendingKey);
        if(input&&pending?.path===location.pathname){
          inputs.forEach((field,index)=>{const value=pending.fields?.[field.name]??(index===0?pending.text:null);if(typeof value==='string'){field.value=value;field.dispatchEvent(new Event('input',{bubbles:true}));}});confirm.checked=false;
        }
      } catch {}
      $$('[data-product-choice]').forEach(link=>link.addEventListener('click',()=>{
        try {
          sessionStorage.removeItem(pendingKey);
          const next=new URL(link.href,location.href);
          if(inputs.some(field=>field.value)&&next.pathname.includes('personalised'))sessionStorage.setItem(pendingKey,JSON.stringify({path:next.pathname,fields:Object.fromEntries(inputs.map(field=>[field.name,field.value]))}));
        } catch {}
      },options));
      wrapper?.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',()=>{
        const target=document.getElementById(link.getAttribute('href').slice(1));
        if(target?.tagName==='DETAILS')target.open=true;
        if(target?.closest('details'))target.closest('details').open=true;
        if(link.hash==='#nano-engraving')requestAnimationFrame(focusEngraving);
      },options));
      const menu=wrapper?.querySelector('#mobile-menu'), toggle=wrapper?.querySelector('.menu-toggle');
      toggle?.addEventListener('click',()=>{menu.hidden=!menu.hidden;toggle.setAttribute('aria-expanded',String(!menu.hidden));},options);
      menu?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.hidden=true;toggle.setAttribute('aria-expanded','false');},options));
      document.querySelector('cart-drawer-component')?.setAttribute('auto-open','');
      wrapper?.querySelector('[data-nano-bag]')?.addEventListener('click',()=>document.querySelector('#cart-drawer')?.open(),options);
      const hash=()=>{if(location.hash==='#nano-engraving')focusEngraving();};
      addEventListener('hashchange',hash,options);
      requestAnimationFrame(()=>{if(input)syncText();setGallery(0,false);updateSticky();hash();});
    }
    disconnectedCallback(){this.controller?.abort();this.buttonObserver?.disconnect();this.galleryObserver?.disconnect();this.colourObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);cancelAnimationFrame(this.galleryFrame);}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-bundle-hero-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nano-bundle-hero-cutout')) {
  customElements.define('nano-bundle-hero-cutout', class extends HTMLElement {
    connectedCallback() {
      const image = this.querySelector('img');
      if (!image || this.dataset.processed) return;
      this.dataset.processed = 'pending';
      const prepare = () => {
        try {
          const scale = Math.min(1, 2000 / Math.max(image.naturalWidth, image.naturalHeight));
          const width = Math.max(1, Math.round(image.naturalWidth * scale));
          const height = Math.max(1, Math.round(image.naturalHeight * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d', { willReadFrequently:true });
          context.drawImage(image, 0, 0, width, height);
          const pixels = context.getImageData(0, 0, width, height);
          const data = pixels.data;
          const normalise = () => {
            const figure = this.closest('.collection-hero-art--front');
            if (!figure) return;
            let left = width, right = -1, top = height, bottom = -1;
            for (let p = 0; p < width * height; p++) {
              if (data[p * 4 + 3] < 16) continue;
              const x = p % width, y = Math.floor(p / width);
              left = Math.min(left, x); right = Math.max(right, x);
              top = Math.min(top, y); bottom = Math.max(bottom, y);
            }
            if (right < left || bottom < top) return;
            figure.style.setProperty('--hero-source-width', (right - left + 1) / width);
            figure.style.setProperty('--hero-subject-ratio', (bottom - top + 1) / (right - left + 1));
            figure.style.setProperty('--hero-source-x', `${-(left + right + 1) / width * 50}%`);
            figure.style.setProperty('--hero-source-y', `${-(top + bottom + 1) / height * 50}%`);
            figure.style.setProperty('--hero-source-top', `${-top / height * 100}%`);
          };
          if (this.hasAttribute('data-measure-only')) {
            normalise();
            this.dataset.processed = 'original';
            return;
          }
          const corners = [0, width - 1, (height - 1) * width, width * height - 1];
          const backgrounds = corners.filter(p => {
            const i = p * 4;
            return data[i + 3] > 240 && Math.min(data[i], data[i + 1], data[i + 2]) > 220 && Math.max(data[i], data[i + 1], data[i + 2]) - Math.min(data[i], data[i + 1], data[i + 2]) < 25;
          }).map(p => Array.from(data.slice(p * 4, p * 4 + 3)));
          if (!backgrounds.length) { normalise(); this.dataset.processed = 'original'; return; }
          const seen = new Uint8Array(width * height);
          const queue = new Int32Array(width * height);
          let head = 0;
          let tail = 0;
          const visit = p => {
            if (seen[p]) return;
            seen[p] = 1;
            const i = p * 4;
            if (data[i + 3] < 16 || backgrounds.some(bg => Math.max(Math.abs(data[i] - bg[0]), Math.abs(data[i + 1] - bg[1]), Math.abs(data[i + 2] - bg[2])) < 26)) {
              data[i + 3] = 0;
              queue[tail++] = p;
            }
          };
          for (let x = 0; x < width; x++) { visit(x); visit((height - 1) * width + x); }
          for (let y = 0; y < height; y++) { visit(y * width); visit(y * width + width - 1); }
          while (head < tail) {
            const p = queue[head++];
            const x = p % width;
            if (x > 0) visit(p - 1);
            if (x < width - 1) visit(p + 1);
            if (p >= width) visit(p - width);
            if (p < width * (height - 1)) visit(p + width);
          }
          if (this.hasAttribute('data-clear-openings')) {
            const collect = p => {
              if (seen[p]) return;
              seen[p] = 1;
              const i = p * 4;
              if (backgrounds.some(bg => Math.max(Math.abs(data[i] - bg[0]), Math.abs(data[i + 1] - bg[1]), Math.abs(data[i + 2] - bg[2])) < 26)) queue[tail++] = p;
            };
            for (let start = 0; start < width * height; start++) {
              if (seen[start]) continue;
              head = 0;
              tail = 0;
              collect(start);
              while (head < tail) {
                const p = queue[head++];
                const x = p % width;
                if (x > 0) collect(p - 1);
                if (x < width - 1) collect(p + 1);
                if (p >= width) collect(p - width);
                if (p < width * (height - 1)) collect(p + width);
              }
              const keyGap = this.hasAttribute('data-clear-key-gap') && tail > 4 && Array.from(queue.subarray(0, tail)).every(p => {
                const x = (p % width) / width;
                const y = Math.floor(p / width) / height;
                return x > 0.22 && x < 0.29 && y > 0.25 && y < 0.35;
              });
              if (tail > width * height * 0.001 || keyGap) {
                for (let i = 0; i < tail; i++) data[queue[i] * 4 + 3] = 0;
              }
            }
          }
          const distance = new Uint16Array(width * height);
          const inset = Math.max(1, Math.ceil(Math.max(width, height) / 700));
          for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
              const p = y * width + x;
              if (!data[p * 4 + 3]) continue;
              let nearest = 65534;
              if (x > 0) nearest = Math.min(nearest, distance[p - 1]);
              if (y > 0) {
                nearest = Math.min(nearest, distance[p - width]);
                if (x > 0) nearest = Math.min(nearest, distance[p - width - 1]);
                if (x < width - 1) nearest = Math.min(nearest, distance[p - width + 1]);
              }
              distance[p] = nearest + 1;
            }
          }
          for (let y = height - 1; y >= 0; y--) {
            for (let x = width - 1; x >= 0; x--) {
              const p = y * width + x;
              if (!distance[p]) continue;
              let nearest = 65534;
              if (x < width - 1) nearest = Math.min(nearest, distance[p + 1]);
              if (y < height - 1) {
                nearest = Math.min(nearest, distance[p + width]);
                if (x > 0) nearest = Math.min(nearest, distance[p + width - 1]);
                if (x < width - 1) nearest = Math.min(nearest, distance[p + width + 1]);
              }
              distance[p] = Math.min(distance[p], nearest + 1);
            }
          }
          for (let p = 0; p < distance.length; p++) {
            const i = p * 4;
            data[i] = 255;
            data[i + 1] = 255;
            data[i + 2] = 255;
            if (distance[p] <= inset) data[i + 3] = 0;
          }
          context.putImageData(pixels, 0, 0);
          image.style.maskImage = `url("${canvas.toDataURL('image/png')}")`;
          image.style.maskSize = 'contain';
          image.style.maskPosition = 'center';
          image.style.maskRepeat = 'no-repeat';
          normalise();
          this.dataset.processed = 'ready';
        } catch {
          this.dataset.processed = 'unavailable';
        }
      };
      if (image.complete && image.naturalWidth) prepare();
      else image.addEventListener('load', prepare, { once:true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-bundle-image-preview"]) return;
  try {
    
if (!customElements.get('nano-bundle-image-product')) {
  customElements.define('nano-bundle-image-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const $ = selector => this.querySelector(selector);
      const $$ = selector => [...this.querySelectorAll(selector)];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduced ? 'instant' : 'smooth';
      const form = $('product-form-component form');
      const inputs = $$('[data-nano-engraving-input]');
      const input = inputs[0];
      const confirm = $('[data-nano-engraving-confirm]');
      const previews = $$('[data-nano-text-preview]');
      const emptyPreviews = new Map(previews.map(preview => [preview, preview.textContent]));
      const mainButton = $('.add-to-bag');
      const sticky = $('.sticky-purchase');
      const stickyButton = $('.sticky-button');
      const track = $('.gallery-track');
      const thumbs = $$('.gallery-thumb');
      const slides = $$('.gallery-slide');
      const zoom = $('#zoom-dialog');
      const gallery = $('.gallery');
      const sizeGallery = () => gallery?.style.setProperty('--nano-gallery-top',`${Math.min(24,innerHeight-gallery.getBoundingClientRect().height-24)}px`);
      this.galleryObserver?.disconnect();
      this.galleryObserver = new ResizeObserver(sizeGallery);
      if(gallery)this.galleryObserver.observe(gallery);
      addEventListener('resize',sizeGallery,options);
      let frame = 0;
      const setGallery = (next, scroll=true) => {
        if (!slides.length) return;
        frame = (next+slides.length)%slides.length;
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed',String(i===frame)));
        $('.gallery-count').textContent = `${String(frame+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
        $('.gallery-caption').textContent=slides[frame].dataset.caption||slides[frame].getAttribute('aria-label');
        if (scroll) track.scrollTo({left:frame*track.clientWidth,behavior});
        if (zoom.open) {
          const photo=slides[frame].querySelector('img');
          const zoomContainer=$('.zoom-image-container');
          zoomContainer.querySelector('.bc-composition')?.remove();
          const composition=slides[frame].querySelector('.bc-composition');
          zoomContainer.classList.toggle('has-bundle-composition',!!composition);
          if(composition){
            const copy=composition.cloneNode(true);
            copy.querySelectorAll('img').forEach(image=>{image.sizes='min(85vw, 900px)';});
            zoomContainer.append(copy);
          }else{
            const zoomImage=zoomContainer.querySelector(':scope > img');
            zoomImage.src=thumbs[frame].dataset.large;
            zoomImage.alt=photo.alt;
            zoomImage.className=photo.className;
            zoomImage.style.setProperty('--nano-image-mask',photo.style.getPropertyValue('--nano-image-mask'));
          }
          $('.zoom-caption').textContent=`${$('.gallery-caption').textContent} · ${$('.gallery-count').textContent}`;
          $('.zoom-image-container').classList.remove('is-magnified');
        }
      };
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>setGallery(i),options));
      $('.gallery-previous')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.gallery-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      track?.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.galleryFrame);
        this.galleryFrame=requestAnimationFrame(()=>setGallery(Math.round(track.scrollLeft/track.clientWidth),false));
      },{...options,passive:true});
      track?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();setGallery(event.key==='Home'?0:event.key==='End'?slides.length-1:frame+(event.key==='ArrowRight'?1:-1));
      },options);
      $('.zoom-open')?.addEventListener('click',()=>{zoom.showModal();setGallery(frame,false);},options);
      $('.zoom-prev')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.zoom-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      $('.zoom-image-container')?.addEventListener('click',()=>$('.zoom-image-container').classList.toggle('is-magnified'),options);
      zoom?.querySelector('.close-dialog')?.addEventListener('click',()=>zoom.close(),options);
      zoom?.addEventListener('click',event=>{if(event.target===zoom)zoom.close();},options);
      zoom?.addEventListener('keydown',event=>{
        if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();setGallery(frame+(event.key==='ArrowRight'?1:-1));}
      },options);

      const colours={
        'Phantom Black':'#29282b','Ghost Silver':'#d1d2ce','Forza Grey':'#93a3a9','Heritage Green':'#8d9e70','Riviera Navy':'#34485b','Portofino Red':'#b1333b','Volcano Red':'#ce352b','Ventura Orange':'#c77235','Spectre Gold':'#bcab84','Spyder Grey':'#717578','Titan Gunmetal':'#626568','Sonic Copper':'#a56946','Racing Green':'#2e5146','Skyfall Navy':'#293d59','Carrera White':'#eeeae3','Nebula Purple':'#684766','Viper Green':'#8dba41','Dark Storm':'#35393d','Onyx Eclipse':'#222225','Flame Burnt':'linear-gradient(135deg,#385d90,#a9664e,#99783b)','Velocity Blue':'#2d84b8','Stealth Black':'#262626','Nero':'#262626','Nero/Argento':'linear-gradient(135deg,#292929 45%,#b7b6b0 55%)','Nero/Viola':'linear-gradient(135deg,#292929 45%,#73498b 55%)','Nero/Arancione':'linear-gradient(135deg,#292929 45%,#d5752e 55%)','Nero/Rosso':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Nero/Verde':'linear-gradient(135deg,#292929 45%,#49965a 55%)','Nero/Oro':'linear-gradient(135deg,#292929 45%,#b4a05a 55%)','Nero/Azzuro':'linear-gradient(135deg,#292929 45%,#327cb4 55%)','Diablo Red/Stealth Black':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Ocean Mist':'#bacdd0','Orchard Mint':'#c1ccb6','Sunset Blush':'#d7b3b7','Twilight Lilac':'#b5a7c5'};
      const aluminiumWallet=this.hasAttribute('data-aluminium-wallet');
      const carbonOrder=this.dataset.walletMaterial==='CARBON FIBRE 3K'?["Stealth Black","Diablo Red/Stealth Black","Stealth Black/Nebula Purple","Stealth Black/Ventura Orange","Stealth Black/Volcano Red","Stealth Black/Miami Blue","Stealth Black/Viper Green","Stealth Black/Ghost Silver","Stealth Black/Spectre Gold"]:this.dataset.walletMaterial==='FORGED CARBON'?["Nero","Nero/Argento","Nero/Oro","Nero/Verde","Nero/Azzuro","Nero/Rosso","Nero/Arancione","Nero/Viola"]:null;
      const approvedOrder=carbonOrder||(aluminiumWallet?['Phantom Black','Titan Gunmetal','Forza Grey','Spyder Grey','Ghost Silver','Carrera White','Spectre Gold','Sonic Copper','Racing Green','Heritage Green','Viper Green','Skyfall Navy','Riviera Navy','Velocity Blue','Portofino Red','Volcano Red','Ventura Orange','Nebula Purple','Dark Storm','Onyx Eclipse','Flame Burnt']:['Phantom Black','Ghost Silver','Forza Grey','Heritage Green','Riviera Navy','Portofino Red','Volcano Red','Ventura Orange','Spectre Gold','Spyder Grey']);
      const rank=link=>{const index=approvedOrder.indexOf(link.title);return index<0?approvedOrder.length:index;};
      const swatches=$$('.swatch').sort((a,b)=>rank(a)-rank(b));
      swatches.forEach(link=>$('.swatches').append(link));
      swatches.forEach(link=>link.style.setProperty('--swatch',colours[link.getAttribute('title')]||'#777'));
      if ($('[data-colour-count]')) $('[data-colour-count]').textContent=this.dataset.colourLabel.replace('[count]',swatches.length);
      const colourRail=$('.swatches'),colourNavigation=$('.swatch-navigation'),colourBack=$('.swatch-back'),colourForward=$('.swatch-forward');
      if(colourRail&&colourBack&&colourForward){
        const syncColourArrows=()=>{
          const maximum=colourRail.scrollWidth-colourRail.clientWidth;
          const position=Math.abs(colourRail.scrollLeft);
          const focused=document.activeElement;
          [[colourBack,position<=2],[colourForward,position>=maximum-2]].forEach(([button,unavailable])=>{
            button.disabled=unavailable;
            button.classList.toggle('is-unavailable',unavailable);
          });
          if((focused===colourBack||focused===colourForward)&&(focused.disabled||focused.hidden)){
            const available=[colourBack,colourForward].find(button=>!button.disabled&&!button.hidden);
            (available||$('.swatch[aria-current="page"]')||swatches[0])?.focus({preventScroll:true});
          }
        };
        const sizeColourNavigation=()=>{
          const style=getComputedStyle(colourRail);
          const contentWidth=swatches.reduce((width,swatch)=>width+swatch.getBoundingClientRect().width,0)+Math.max(0,swatches.length-1)*(parseFloat(style.columnGap)||0)+(parseFloat(style.paddingLeft)||0)+(parseFloat(style.paddingRight)||0);
          const overflows=contentWidth>colourNavigation.clientWidth+2;
          colourBack.hidden=!overflows;
          colourForward.hidden=!overflows;
          syncColourArrows();
        };
        const scrollColours=direction=>{
          const sign=getComputedStyle(colourRail).direction==='rtl'?-1:1;
          colourRail.scrollBy({left:direction*sign*colourRail.clientWidth*.8,behavior});
        };
        colourBack.addEventListener('click',()=>scrollColours(-1),options);
        colourForward.addEventListener('click',()=>scrollColours(1),options);
        colourRail.addEventListener('scroll',syncColourArrows,{...options,passive:true});
        this.colourObserver=new ResizeObserver(sizeColourNavigation);
        this.colourObserver.observe(colourNavigation);
        requestAnimationFrame(()=>{
          sizeColourNavigation();
          const selected=$('.swatch[aria-current="page"]');
          colourRail.scrollLeft=0;
          if(selected&&!aluminiumWallet&&!carbonOrder){
            const delta=selected.getBoundingClientRect().right-colourRail.getBoundingClientRect().right;
            if(delta>0)colourRail.scrollLeft=delta+4;
          }
          syncColourArrows();
        });
      }
      $('.swatches')?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();const i=swatches.indexOf(document.activeElement);
        const n=event.key==='Home'?0:event.key==='End'?swatches.length-1:(i+(event.key==='ArrowRight'?1:-1)+swatches.length)%swatches.length;
        swatches[n].focus();
      },options);

      const focusEngraving=()=>{
        if(!input)return;
        const target=inputs.find(field=>!field.validity.valid)||input;
        target.closest('details').open=true;
        target.scrollIntoView({behavior,block:'center'});target.focus({preventScroll:true});
      };
      const syncText=()=>{
        previews.forEach(preview=>{const field=inputs.find(field=>field.name===preview.dataset.nanoTextPreview);preview.textContent=field?.value.trim()?field.value:emptyPreviews.get(preview);});
        updateSticky();
      };
      inputs.forEach(field=>field.addEventListener('input',syncText,options));
      confirm?.addEventListener('change',()=>updateSticky(),options);
      form?.addEventListener('invalid',event=>{const details=event.target.closest('details');if(details)details.open=true;},{...options,capture:true});
      form?.addEventListener('submit',event=>{
        if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
      },{...options,capture:true});
      $('[data-nano-variant]')?.addEventListener('change',event=>{
        const next=new URL(location.href);next.searchParams.set('variant',event.target.value);const quantity=form?.querySelector('[name="quantity"]');if(quantity?.validity.valid)next.searchParams.set('quantity',quantity.value);location.assign(next);
      },options);
      const updateSticky=()=>{
        if(!mainButton||!sticky)return;
        const rect=mainButton.getBoundingClientRect();
        const before=rect.top>innerHeight;
        const activeField=document.activeElement;
        const focusInField=activeField?.matches('textarea, select, input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"])');
        const galleryPassed=$('.gallery-stage').getBoundingClientRect().top<0;
        const footerVisible=this.closest('.nano-draft2').querySelector('footer').getBoundingClientRect().top<innerHeight;
        const show=rect.bottom<0||(matchMedia('(max-width:700px)').matches&&before&&galleryPassed);
        sticky.hidden=!show||focusInField||zoom.open||footerVisible;
        sticky.classList.toggle('is-before',before);
        stickyButton.disabled=mainButton.disabled;
        stickyButton.firstElementChild.textContent=mainButton.disabled?mainButton.firstElementChild.textContent:before?sticky.dataset.chooseLabel:input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)?sticky.dataset.personaliseLabel:sticky.dataset.addLabel;
      };
      stickyButton?.addEventListener('click',()=>{
        if(mainButton.disabled)return;
        if(sticky.classList.contains('is-before')){$('.purchase-options').scrollIntoView({behavior,block:'center'});return;}
        if(input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)){focusEngraving();form.reportValidity();return;}
        form.requestSubmit(mainButton);
      },options);
      addEventListener('scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(updateSticky);},{...options,passive:true});
      addEventListener('resize',updateSticky,options);
      document.addEventListener('focusin',updateSticky,options);
      document.addEventListener('focusout',()=>requestAnimationFrame(updateSticky),options);
      this.buttonObserver=new MutationObserver(updateSticky);if(mainButton)this.buttonObserver.observe(mainButton,{attributes:true,attributeFilter:['disabled']});
      $$('.products-section').forEach(section=>{
        const row=section.querySelector('.product-row');
        section.querySelector('.row-next')?.addEventListener('click',()=>row.scrollBy({left:row.clientWidth*.8,behavior}),options);
        section.querySelector('.row-prev')?.addEventListener('click',()=>row.scrollBy({left:-row.clientWidth*.8,behavior}),options);
        row?.addEventListener('scroll',()=>section.querySelector('.row-controls').classList.toggle('can-go-back',row.scrollLeft>10),{...options,passive:true});
      });
      const wrapper=this.closest('.nano-draft2');
      const pendingKey='nano-product-engraving-transfer';
      try {
        const pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');
        sessionStorage.removeItem(pendingKey);
        if(input&&pending?.path===location.pathname){
          inputs.forEach((field,index)=>{const value=pending.fields?.[field.name]??(index===0?pending.text:null);if(typeof value==='string'){field.value=value;field.dispatchEvent(new Event('input',{bubbles:true}));}});confirm.checked=false;
        }
      } catch {}
      $$('[data-product-choice]').forEach(link=>link.addEventListener('click',()=>{
        try {
          sessionStorage.removeItem(pendingKey);
          const next=new URL(link.href,location.href);
          if(inputs.some(field=>field.value)&&next.pathname.includes('personalised'))sessionStorage.setItem(pendingKey,JSON.stringify({path:next.pathname,fields:Object.fromEntries(inputs.map(field=>[field.name,field.value]))}));
        } catch {}
      },options));
      wrapper?.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',()=>{
        const target=document.getElementById(link.getAttribute('href').slice(1));
        if(target?.tagName==='DETAILS')target.open=true;
        if(target?.closest('details'))target.closest('details').open=true;
        if(link.hash==='#nano-engraving')requestAnimationFrame(focusEngraving);
      },options));
      const menu=wrapper?.querySelector('#mobile-menu'), toggle=wrapper?.querySelector('.menu-toggle');
      toggle?.addEventListener('click',()=>{menu.hidden=!menu.hidden;toggle.setAttribute('aria-expanded',String(!menu.hidden));},options);
      menu?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.hidden=true;toggle.setAttribute('aria-expanded','false');},options));
      document.querySelector('cart-drawer-component')?.setAttribute('auto-open','');
      wrapper?.querySelector('[data-nano-bag]')?.addEventListener('click',()=>document.querySelector('#cart-drawer')?.open(),options);
      const hash=()=>{if(location.hash==='#nano-engraving')focusEngraving();};
      addEventListener('hashchange',hash,options);
      requestAnimationFrame(()=>{if(input)syncText();setGallery(0,false);updateSticky();hash();});
    }
    disconnectedCallback(){this.controller?.abort();this.buttonObserver?.disconnect();this.galleryObserver?.disconnect();this.colourObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);cancelAnimationFrame(this.galleryFrame);}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nano-pocket-campaign')) {
  customElements.define('nano-pocket-campaign', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.requestId = 0;
      this.buttons = Array.from(this.querySelectorAll('[data-pocket-select]'));
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.select(button.dataset.pocketSelect));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.buttons.length) % this.buttons.length;
          this.buttons[next].focus();
          this.select(this.buttons[next].dataset.pocketSelect);
        });
      });
      this.addEventListener('touchstart', event => {
        if (event.target.closest('a, button')) return;
        this.touchStart = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
      }, {passive: true});
      this.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart[0];
        const dy = event.changedTouches[0].clientY - this.touchStart[1];
        this.touchStart = null;
        if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        const index = this.buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        this.select(this.buttons[(index + (dx < 0 ? 1 : -1) + this.buttons.length) % this.buttons.length].dataset.pocketSelect);
      }, {passive: true});
    }
    async select(material) {
      const button = this.buttons.find(item => item.dataset.pocketSelect === material);
      if (!button) return;
      const requestId = ++this.requestId;
      let picture = this.querySelector('picture[data-pocket-slide="' + material + '"]');
      if (!picture) {
        const fragment = this.querySelector('template[data-pocket-template="' + material + '"]').content.cloneNode(true);
        picture = fragment.querySelector('picture');
        picture.hidden = true;
        picture.querySelector('img').loading = 'eager';
        this.prepend(fragment);
      }
      try { await picture.querySelector('img').decode(); } catch { return; }
      if (requestId !== this.requestId) return;
      this.querySelectorAll('picture[data-pocket-slide]').forEach(item => { item.hidden = item !== picture; });
      this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.querySelector('[data-pocket-shop]').href = button.dataset.pocketUrl;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-collection-discovery"]) return;
  try {
    
(() => {
  function initialize() {
    const root = document.getElementById('nano-collection-worlds');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let selected = null;
    const chapters = [...root.querySelectorAll('[data-collection]')];
    const jumps = [...root.querySelectorAll('[data-jump]')];
    const showAll = root.querySelector('.nano-show-all');
    function selectCollection(handle) {
      selected = handle;
      chapters.forEach(chapter => chapter.hidden = !!handle && chapter.dataset.collection !== handle);
      jumps.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.jump === handle)));
      showAll.hidden = !handle;
    }
    root.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {
      const view = button.dataset.view;
      root.querySelector('#nano-material-section').hidden = view === 'signature';
      root.querySelector('#nano-signature-section').hidden = view === 'materials';
      root.querySelectorAll('[data-view]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      root.querySelector('.nano-view-count').textContent = button.dataset.countLabel;
      selectCollection(null);
    }));
    jumps.forEach(button => button.addEventListener('click', () => selectCollection(selected === button.dataset.jump ? null : button.dataset.jump)));
    showAll.addEventListener('click', () => selectCollection(null));
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-collection-header"]) return;
  try {
    
class NanoNavigation extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const button = this.querySelector('.menu-toggle');
    const menu = this.querySelector('#mobile-menu');
    if (!button || !menu) return;
    const close = (focus = false) => {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', this.dataset.openLabel);
      if (focus) button.focus();
    };
    button.addEventListener('click', () => {
      if (!menu.hidden) return close();
      menu.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', this.dataset.closeLabel);
    }, options);
    menu.addEventListener('click', event => { if (event.target.closest('a')) close(); }, options);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) close(true); }, options);
    document.addEventListener('click', event => { if (!menu.hidden && !this.contains(event.target)) close(); }, options);
    matchMedia('(max-width: 700px)').addEventListener('change', () => close(), options);
  }
  disconnectedCallback() { this.controller?.abort(); }
}

class NanoWalletChooser extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const choices = [...this.querySelectorAll('.wallet-choice')];
    const image = this.querySelector('#discovery-image');
    const caption = this.querySelector('#discovery-caption');
    if (!image || !caption) return;
    choices.forEach(choice => choice.addEventListener('toggle', () => {
      if (!choice.open) return;
      choices.forEach(other => { if (other !== choice) other.open = false; });
      if (choice.dataset.srcset) image.srcset = choice.dataset.srcset;
      else image.removeAttribute('srcset');
      image.src = choice.dataset.image;
      image.alt = choice.dataset.alt;
      image.dataset.kind = choice.dataset.wallet;
      caption.textContent = choice.dataset.caption;
    }, { signal: this.controller.signal }));
  }
  disconnectedCallback() { this.controller?.abort(); }
}

class NanoFooter extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const mobile = matchMedia('(max-width: 700px)');
    const columns = [...this.querySelectorAll('.footer-column')];
    const layout = () => columns.forEach(column => {
      column.open = !mobile.matches;
      const summary = column.querySelector('summary');
      summary.tabIndex = mobile.matches ? 0 : -1;
      if (mobile.matches) summary.removeAttribute('aria-disabled');
      else summary.setAttribute('aria-disabled', 'true');
    });
    layout();
    mobile.addEventListener('change', layout, options);
    columns.forEach(column => column.addEventListener('toggle', () => { if (!mobile.matches) column.open = true; }, options));
  }
  disconnectedCallback() { this.controller?.abort(); }
}

class NanoMaterialGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const gallery = this.querySelector('#material-gallery');
    const controls = this.querySelector('.material-controls');
    if (!gallery || !controls) return;
    const cards = [...gallery.querySelectorAll('.material-card')];
    if (!cards.length) return;
    const previous = controls.querySelector('[data-material-direction="previous"]');
    const next = controls.querySelector('[data-material-direction="next"]');
    const position = controls.querySelector('.material-position');
    const status = controls.querySelector('.material-status');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const pad = number => String(number).padStart(2, '0');
    const maximum = () => Math.max(0, gallery.scrollWidth - gallery.clientWidth);
    const geometry = () => {
      const viewport = gallery.getBoundingClientRect();
      return cards.map(card => {
        const rect = card.getBoundingClientRect();
        return { left: rect.left - viewport.left, right: rect.right - viewport.left };
      });
    };
    const sync = () => {
      this.frame = 0;
      previous.setAttribute('aria-disabled', String(gallery.scrollLeft <= 2));
      next.setAttribute('aria-disabled', String(gallery.scrollLeft >= maximum() - 2));
      const sizes = geometry();
      let visible = sizes.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.left >= -2 && rect.right <= gallery.clientWidth + 2);
      if (!visible.length) {
        visible = sizes.map((rect, index) => ({ rect, index, area: Math.max(0, Math.min(rect.right, gallery.clientWidth) - Math.max(rect.left, 0)) })).sort((a,b) => b.area-a.area).slice(0,1);
      }
      const first = visible[0].index + 1;
      const last = visible[visible.length-1].index + 1;
      position.textContent = `${pad(first)} — ${pad(last)} / ${pad(cards.length)}`;
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        const template = first === last ? this.dataset.singleLabel : this.dataset.rangeLabel;
        status.textContent = template.replace('[first]', first).replace('[last]', last).replace('[total]', cards.length);
      }, 180);
    };
    const queue = () => { if (!this.frame) this.frame = requestAnimationFrame(sync); };
    const moveTo = (index, immediate = false) => {
      const target = Math.max(0, Math.min(cards.length-1, index));
      const left = geometry()[target].left + gallery.scrollLeft;
      gallery.scrollTo({ left: Math.max(0, Math.min(maximum(), left)), behavior: immediate || reduced.matches ? 'auto' : 'smooth' });
    };
    const moveBy = direction => {
      const sizes = geometry();
      const current = sizes.reduce((best, rect, index) => Math.abs(rect.left) < Math.abs(sizes[best].left) ? index : best, 0);
      moveTo(current + direction);
    };
    previous.addEventListener('click', () => { if (previous.getAttribute('aria-disabled') !== 'true') moveBy(-1); }, options);
    next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') !== 'true') moveBy(1); }, options);
    gallery.addEventListener('scroll', queue, { ...options, passive:true });
    gallery.addEventListener('keydown', event => {
      if (event.target !== gallery || event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') moveTo(0);
      else if (event.key === 'End') moveTo(cards.length-1);
      else moveBy(event.key === 'ArrowRight' ? 1 : -1);
    }, options);
    gallery.addEventListener('focusin', event => {
      const index = cards.indexOf(event.target.closest('.material-card'));
      if (index < 0) return;
      const rect = geometry()[index];
      if (rect.left < -2 || rect.right > gallery.clientWidth + 2) moveTo(index, true);
    }, options);
    this.observer = new ResizeObserver(queue);
    this.observer.observe(gallery);
    controls.hidden = false;
    sync();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    clearTimeout(this.announceTimer);
    cancelAnimationFrame(this.frame);
  }
}

for (const [name, component] of [['nano-navigation',NanoNavigation],['nano-wallet-chooser',NanoWalletChooser],['nano-footer',NanoFooter],['nano-material-gallery',NanoMaterialGallery]]) {
  if (!customElements.get(name)) customElements.define(name, component);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-collection-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nano-hero-cutout')) {
  customElements.define('nano-hero-cutout', class extends HTMLElement {
    connectedCallback() {
      const image = this.querySelector('img');
      if (!image || this.dataset.processed) return;
      this.dataset.processed = 'pending';
      const prepare = () => {
        try {
          const scale = Math.min(1, 2000 / Math.max(image.naturalWidth, image.naturalHeight));
          const width = Math.max(1, Math.round(image.naturalWidth * scale));
          const height = Math.max(1, Math.round(image.naturalHeight * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d', { willReadFrequently:true });
          context.drawImage(image, 0, 0, width, height);
          const pixels = context.getImageData(0, 0, width, height);
          const data = pixels.data;
          const normalise = () => {
            const figure = this.closest('.collection-hero-art--front');
            if (!figure) return;
            let left = width, right = -1, top = height, bottom = -1;
            for (let p = 0; p < width * height; p++) {
              if (data[p * 4 + 3] < 16) continue;
              const x = p % width, y = Math.floor(p / width);
              left = Math.min(left, x); right = Math.max(right, x);
              top = Math.min(top, y); bottom = Math.max(bottom, y);
            }
            if (right < left || bottom < top) return;
            figure.style.setProperty('--hero-source-width', (right - left + 1) / width);
            figure.style.setProperty('--hero-subject-ratio', (bottom - top + 1) / (right - left + 1));
            figure.style.setProperty('--hero-source-x', `${-(left + right + 1) / width * 50}%`);
            figure.style.setProperty('--hero-source-y', `${-(top + bottom + 1) / height * 50}%`);
            figure.style.setProperty('--hero-source-top', `${-top / height * 100}%`);
          };
          if (this.hasAttribute('data-measure-only')) {
            normalise();
            this.dataset.processed = 'original';
            return;
          }
          const corners = [0, width - 1, (height - 1) * width, width * height - 1];
          const backgrounds = corners.filter(p => {
            const i = p * 4;
            return data[i + 3] > 240 && Math.min(data[i], data[i + 1], data[i + 2]) > 220 && Math.max(data[i], data[i + 1], data[i + 2]) - Math.min(data[i], data[i + 1], data[i + 2]) < 25;
          }).map(p => Array.from(data.slice(p * 4, p * 4 + 3)));
          if (!backgrounds.length) { normalise(); this.dataset.processed = 'original'; return; }
          const seen = new Uint8Array(width * height);
          const queue = new Int32Array(width * height);
          let head = 0;
          let tail = 0;
          const visit = p => {
            if (seen[p]) return;
            seen[p] = 1;
            const i = p * 4;
            if (data[i + 3] < 16 || backgrounds.some(bg => Math.max(Math.abs(data[i] - bg[0]), Math.abs(data[i + 1] - bg[1]), Math.abs(data[i + 2] - bg[2])) < 26)) {
              data[i + 3] = 0;
              queue[tail++] = p;
            }
          };
          for (let x = 0; x < width; x++) { visit(x); visit((height - 1) * width + x); }
          for (let y = 0; y < height; y++) { visit(y * width); visit(y * width + width - 1); }
          while (head < tail) {
            const p = queue[head++];
            const x = p % width;
            if (x > 0) visit(p - 1);
            if (x < width - 1) visit(p + 1);
            if (p >= width) visit(p - width);
            if (p < width * (height - 1)) visit(p + width);
          }
          if (this.hasAttribute('data-clear-openings')) {
            const collect = p => {
              if (seen[p]) return;
              seen[p] = 1;
              const i = p * 4;
              if (backgrounds.some(bg => Math.max(Math.abs(data[i] - bg[0]), Math.abs(data[i + 1] - bg[1]), Math.abs(data[i + 2] - bg[2])) < 26)) queue[tail++] = p;
            };
            for (let start = 0; start < width * height; start++) {
              if (seen[start]) continue;
              head = 0;
              tail = 0;
              collect(start);
              while (head < tail) {
                const p = queue[head++];
                const x = p % width;
                if (x > 0) collect(p - 1);
                if (x < width - 1) collect(p + 1);
                if (p >= width) collect(p - width);
                if (p < width * (height - 1)) collect(p + width);
              }
              const keyGap = this.hasAttribute('data-clear-key-gap') && tail > 4 && Array.from(queue.subarray(0, tail)).every(p => {
                const x = (p % width) / width;
                const y = Math.floor(p / width) / height;
                return x > 0.22 && x < 0.29 && y > 0.25 && y < 0.35;
              });
              if (tail > width * height * 0.001 || keyGap) {

                for (let i = 0; i < tail; i++) data[queue[i] * 4 + 3] = 0;
              }
            }
          }
          const distance = new Uint16Array(width * height);
          const inset = Math.max(1, Math.ceil(Math.max(width, height) / 700));
          for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
              const p = y * width + x;
              if (!data[p * 4 + 3]) continue;
              let nearest = 65534;
              if (x > 0) nearest = Math.min(nearest, distance[p - 1]);
              if (y > 0) {
                nearest = Math.min(nearest, distance[p - width]);
                if (x > 0) nearest = Math.min(nearest, distance[p - width - 1]);
                if (x < width - 1) nearest = Math.min(nearest, distance[p - width + 1]);
              }
              distance[p] = nearest + 1;
            }
          }
          for (let y = height - 1; y >= 0; y--) {
            for (let x = width - 1; x >= 0; x--) {
              const p = y * width + x;
              if (!distance[p]) continue;
              let nearest = 65534;
              if (x < width - 1) nearest = Math.min(nearest, distance[p + 1]);
              if (y < height - 1) {
                nearest = Math.min(nearest, distance[p + width]);
                if (x > 0) nearest = Math.min(nearest, distance[p + width - 1]);
                if (x < width - 1) nearest = Math.min(nearest, distance[p + width + 1]);
              }
              distance[p] = Math.min(distance[p], nearest + 1);
            }
          }
          for (let p = 0; p < distance.length; p++) {
            const i = p * 4;
            data[i] = 255;
            data[i + 1] = 255;
            data[i + 2] = 255;
            if (distance[p] <= inset) data[i + 3] = 0;
          }
          context.putImageData(pixels, 0, 0);
          image.style.maskImage = `url("${canvas.toDataURL('image/png')}")`;
          image.style.maskSize = 'contain';
          image.style.maskPosition = 'center';
          image.style.maskRepeat = 'no-repeat';
          normalise();
          this.dataset.processed = 'ready';
        } catch {
          this.dataset.processed = 'unavailable';
        }
      };
      if (image.complete && image.naturalWidth) prepare();
      else image.addEventListener('load', prepare, { once:true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-collection-main"] && !Shopify.designMode) return;
  try {
    
class NanoCollectionBrowser extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    const signal = this.events.signal;
    const dialog = this.querySelector('dialog');
    const opener = this.querySelector('#filter-open');
    opener?.addEventListener('click', () => dialog.showModal(), {signal});
    this.querySelector('[data-close-filters]')?.addEventListener('click', () => dialog.close(), {signal});
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, {signal});
    dialog?.addEventListener('close', () => opener.focus({preventScroll:true}), {signal});
    this.querySelector('#sort-select')?.addEventListener('change', event => event.target.form.requestSubmit(), {signal});
    const nav = this.querySelector('.material-navigation');
    const rail = nav?.querySelector('.material-navigation__rail');
    if (!rail) return;
    const controls = nav.querySelector('.material-navigation__controls');
    const previous = controls.querySelector('button:first-child');
    const next = controls.querySelector('button:last-child');
    const desktop = matchMedia('(min-width:701px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const behavior = () => reduced.matches ? 'instant' : 'smooth';
    const update = () => {
      controls.hidden = !desktop.matches || rail.scrollWidth <= nav.clientWidth + 1;
      previous.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
    };
    const reveal = link => {
      const item = link.getBoundingClientRect();
      const view = rail.getBoundingClientRect();
      if (item.left < view.left || item.right > view.right) rail.scrollBy({left:item.left < view.left ? item.left-view.left : item.right-view.right,behavior:behavior()});
    };
    previous.addEventListener('click', () => rail.scrollBy({left:-rail.clientWidth*.75,behavior:behavior()}), {signal});
    next.addEventListener('click', () => rail.scrollBy({left:rail.clientWidth*.75,behavior:behavior()}), {signal});
    rail.addEventListener('scroll', update, {passive:true,signal});
    rail.addEventListener('focusin', event => {const link=event.target.closest('a');if(link)reveal(link);}, {signal});
    let gesture;
    let suppressUntil = 0;
    rail.addEventListener('pointerdown', event => {suppressUntil=0;gesture={id:event.pointerId,x:event.clientX,y:event.clientY,scroll:rail.scrollLeft,moved:false};}, {passive:true,signal});
    rail.addEventListener('pointermove', event => {if(gesture?.id===event.pointerId&&Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>8)gesture.moved=true;}, {passive:true,signal});
    const finish = event => {if(gesture?.id!==event.pointerId)return;if(gesture.moved||Math.abs(rail.scrollLeft-gesture.scroll)>8||event.type==='pointercancel')suppressUntil=performance.now()+700;gesture=null;};
    rail.addEventListener('pointerup',finish,{passive:true,signal});
    rail.addEventListener('pointercancel',finish,{passive:true,signal});
    rail.addEventListener('click',event=>{if(event.detail!==0&&performance.now()<suppressUntil)event.preventDefault();},{capture:true,signal});
    desktop.addEventListener('change',update,{signal});
    this.observer = new ResizeObserver(update);
    this.observer.observe(nav);
    this.observer.observe(rail);
    update();
    document.fonts.ready.then(()=>{if(!this.isConnected)return;update();const selected=rail.querySelector('[aria-current="page"]');if(selected)reveal(selected);});
  }
  disconnectedCallback() {this.events?.abort();this.observer?.disconnect();}
}
if (!customElements.get('nano-collection-browser')) customElements.define('nano-collection-browser',NanoCollectionBrowser);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-corporate-branding"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nano-corporate-carousel')) {
    customElements.define('nano-corporate-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const controller = new AbortController();
        this.controller = controller;
        queueMicrotask(() => {
          if (!this.isConnected || this.controller !== controller) return;
          this.viewport = this.querySelector('.branding-carousel__viewport');
          this.slides = [...this.querySelectorAll('.branding-carousel__slide')];
          this.controls = this.querySelector('.branding-carousel__controls');
          this.previous = this.querySelector('[data-carousel-prev]');
          this.next = this.querySelector('[data-carousel-next]');
          this.current = this.querySelector('[data-carousel-current]');
          const total = this.querySelector('[data-carousel-total]');
          if (!this.viewport || !this.slides.length || !this.controls || !this.previous || !this.next || !this.current || !total) return;
          this.activeIndex = 0;
          this.viewportWidth = this.viewport.clientWidth;
          this.numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'en');
          this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
          total.textContent = this.numberFormat.format(this.slides.length);
          this.controls.hidden = this.slides.length < 2;
          if (this.slides.length < 2) this.removeAttribute('tabindex');
          const signal = controller.signal;
          this.viewport.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
          this.previous.addEventListener('click', () => this.goTo(this.activeIndex - 1), { signal });
          this.next.addEventListener('click', () => this.goTo(this.activeIndex + 1), { signal });
          this.addEventListener('keydown', event => {
            if (this.slides.length < 2 || event.altKey || event.ctrlKey || event.metaKey) return;
            if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
            const direction = getComputedStyle(this.viewport).direction === 'rtl' ? -1 : 1;
            let target;
            if (event.key === 'ArrowRight') target = this.activeIndex + direction;
            else if (event.key === 'ArrowLeft') target = this.activeIndex - direction;
            else if (event.key === 'Home') target = 0;
            else if (event.key === 'End') target = this.slides.length - 1;
            else return;
            event.preventDefault();
            this.goTo(target);
          }, { signal });
          this.resizeObserver = new ResizeObserver(() => {
            const width = this.viewport.clientWidth;
            if (width && width !== this.viewportWidth) {
              this.viewportWidth = width;
              this.goTo(this.activeIndex, true);
            }
            this.scheduleUpdate();
          });
          this.resizeObserver.observe(this.viewport);
          this.update();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
        if (this.frame !== undefined) cancelAnimationFrame(this.frame);
        this.frame = undefined;
      }

      scheduleUpdate() {
        if (this.frame !== undefined) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = undefined;
          if (this.isConnected && this.controller) this.update();
        });
      }

      update() {
        const width = this.viewport.clientWidth;
        if (!width) return;
        this.activeIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(Math.abs(this.viewport.scrollLeft) / width)));
        this.current.textContent = this.numberFormat.format(this.activeIndex + 1);
        this.previous.disabled = this.activeIndex === 0;
        this.next.disabled = this.activeIndex === this.slides.length - 1;
        this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.activeIndex)));
      }

      goTo(index, instant = false) {
        const target = Math.max(0, Math.min(this.slides.length - 1, index));
        const direction = getComputedStyle(this.viewport).direction === 'rtl' ? -1 : 1;
        this.viewport.scrollTo({
          left: direction * target * this.viewport.clientWidth,
          behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-corporate-enquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root = document) {
      root.querySelectorAll('[data-nano-corporate-form]').forEach(form => {
        if (form.dataset.corporateInitialized) return;
        form.dataset.corporateInitialized = 'true';
        const success = form.querySelector('[data-corporate-server-success]');
        if (success) { success.focus(); return; }
        const button = form.querySelector('[type="submit"]');
        const label = form.querySelector('[data-corporate-submit-label]');
        const progress = form.querySelector('[data-corporate-progress]');
        if (!button || !label || !progress) return;
        const initialLabel = label.textContent;
        let submitting = false;
        function reset() {
          submitting = false;
          form.removeAttribute('aria-busy');
          button.removeAttribute('aria-disabled');
          label.textContent = initialLabel;
          progress.hidden = true;
        }
        form.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach(field => {
          function validate() {
            field.setCustomValidity(field.required && !field.value.trim() ? progress.dataset.requiredMessage : '');
            if (field.validity.valid) field.removeAttribute('aria-invalid');
          }
          field.addEventListener('input', validate);
          field.addEventListener('change', validate);
          field.addEventListener('invalid', () => field.setAttribute('aria-invalid', 'true'));
        });
        button.addEventListener('click', event => {
          if (submitting) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, { capture: true });
        form.addEventListener('submit', event => {
          if (submitting) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          if (form.dataset.contactPreview === 'true' || !navigator.onLine) {
            event.preventDefault();
            event.stopImmediatePropagation();
            progress.hidden = false;
            progress.textContent = form.dataset.contactPreview === 'true' ? progress.dataset.previewMessage : progress.dataset.offlineMessage;
            return;
          }
          queueMicrotask(() => {
            if (event.defaultPrevented) return;
            submitting = true;
            form.setAttribute('aria-busy', 'true');
            button.setAttribute('aria-disabled', 'true');
            label.textContent = progress.dataset.sendingMessage;
            progress.textContent = progress.dataset.sendingMessage;
            progress.hidden = false;
          });
        }, { capture: true });
        window.addEventListener('pageshow', reset);
        form.querySelector('[data-corporate-server-error]')?.focus();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-engraving-preview-main"]) return;
  try {
    
if (!customElements.get('nano-product-draft2')) {
  customElements.define('nano-product-draft2', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const $ = selector => this.querySelector(selector);
      const $$ = selector => [...this.querySelectorAll(selector)];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduced ? 'instant' : 'smooth';
      const form = $('product-form-component form');
      const inputs = $$('[data-nano-engraving-input]');
      const input = inputs[0];
      const confirm = $('[data-nano-engraving-confirm]');
      const previews = $$('[data-nano-text-preview]');
      const emptyPreviews = new Map(previews.map(preview => [preview, preview.textContent]));
      const mainButton = $('.add-to-bag');
      const sticky = $('.sticky-purchase');
      const stickyButton = $('.sticky-button');
      const track = $('.gallery-track');
      const thumbs = $$('.gallery-thumb');
      const slides = $$('.gallery-slide');
      const zoom = $('#zoom-dialog');
      const gallery = $('.gallery');
      const sizeGallery = () => gallery?.style.setProperty('--nano-gallery-top',`${Math.min(24,innerHeight-gallery.getBoundingClientRect().height-24)}px`);
      this.galleryObserver?.disconnect();
      this.galleryObserver = new ResizeObserver(sizeGallery);
      if(gallery)this.galleryObserver.observe(gallery);
      addEventListener('resize',sizeGallery,options);
      let frame = 0;
      const setGallery = (next, scroll=true) => {
        if (!slides.length) return;
        frame = (next+slides.length)%slides.length;
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed',String(i===frame)));
        $('.gallery-count').textContent = `${String(frame+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
        $('.gallery-caption').textContent=slides[frame].dataset.caption||slides[frame].getAttribute('aria-label');
        if (scroll) track.scrollTo({left:frame*track.clientWidth,behavior});
        if (zoom.open) {
          const photo=slides[frame].querySelector('img');
          $('.zoom-image-container img').src=thumbs[frame].dataset.large;
          $('.zoom-image-container img').alt=photo.alt;
          $('.zoom-image-container img').className=photo.className;
          $('.zoom-image-container img').style.setProperty('--nano-image-mask',photo.style.getPropertyValue('--nano-image-mask'));
          $('.zoom-caption').textContent=`${$('.gallery-caption').textContent} · ${$('.gallery-count').textContent}`;
          $('.zoom-image-container').classList.remove('is-magnified');
        }
      };
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>setGallery(i),options));
      $('.gallery-previous')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.gallery-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      track?.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.galleryFrame);
        this.galleryFrame=requestAnimationFrame(()=>setGallery(Math.round(track.scrollLeft/track.clientWidth),false));
      },{...options,passive:true});
      track?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();setGallery(event.key==='Home'?0:event.key==='End'?slides.length-1:frame+(event.key==='ArrowRight'?1:-1));
      },options);
      $('.zoom-open')?.addEventListener('click',()=>{zoom.showModal();setGallery(frame,false);},options);
      $('.zoom-prev')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.zoom-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      $('.zoom-image-container')?.addEventListener('click',()=>$('.zoom-image-container').classList.toggle('is-magnified'),options);
      zoom?.querySelector('.close-dialog')?.addEventListener('click',()=>zoom.close(),options);
      zoom?.addEventListener('click',event=>{if(event.target===zoom)zoom.close();},options);
      zoom?.addEventListener('keydown',event=>{
        if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();setGallery(frame+(event.key==='ArrowRight'?1:-1));}
      },options);

      const colours={
        'Phantom Black':'#29282b','Ghost Silver':'#d1d2ce','Forza Grey':'#93a3a9','Heritage Green':'#8d9e70','Riviera Navy':'#34485b','Portofino Red':'#b1333b','Volcano Red':'#ce352b','Ventura Orange':'#c77235','Spectre Gold':'#bcab84','Spyder Grey':'#717578','Titan Gunmetal':'#626568','Sonic Copper':'#a56946','Racing Green':'#2e5146','Skyfall Navy':'#293d59','Carrera White':'#eeeae3','Nebula Purple':'#684766','Viper Green':'#8dba41','Dark Storm':'#35393d','Onyx Eclipse':'#222225','Flame Burnt':'linear-gradient(135deg,#385d90,#a9664e,#99783b)','Velocity Blue':'#2d84b8','Stealth Black':'#262626','Nero':'#262626','Nero/Argento':'linear-gradient(135deg,#292929 45%,#b7b6b0 55%)','Nero/Viola':'linear-gradient(135deg,#292929 45%,#73498b 55%)','Nero/Arancione':'linear-gradient(135deg,#292929 45%,#d5752e 55%)','Nero/Rosso':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Nero/Verde':'linear-gradient(135deg,#292929 45%,#49965a 55%)','Nero/Oro':'linear-gradient(135deg,#292929 45%,#b4a05a 55%)','Nero/Azzuro':'linear-gradient(135deg,#292929 45%,#327cb4 55%)','Diablo Red/Stealth Black':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Ocean Mist':'#bacdd0','Orchard Mint':'#c1ccb6','Sunset Blush':'#d7b3b7','Twilight Lilac':'#b5a7c5'};
      const aluminiumWallet=this.hasAttribute('data-aluminium-wallet');
      const carbonOrder=this.dataset.walletMaterial==='CARBON FIBRE 3K'?["Stealth Black","Diablo Red/Stealth Black","Stealth Black/Nebula Purple","Stealth Black/Ventura Orange","Stealth Black/Volcano Red","Stealth Black/Miami Blue","Stealth Black/Viper Green","Stealth Black/Ghost Silver","Stealth Black/Spectre Gold"]:this.dataset.walletMaterial==='FORGED CARBON'?["Nero","Nero/Argento","Nero/Oro","Nero/Verde","Nero/Azzuro","Nero/Rosso","Nero/Arancione","Nero/Viola"]:null;
      const approvedOrder=carbonOrder||(aluminiumWallet?['Phantom Black','Titan Gunmetal','Forza Grey','Spyder Grey','Ghost Silver','Carrera White','Spectre Gold','Sonic Copper','Racing Green','Heritage Green','Viper Green','Skyfall Navy','Riviera Navy','Velocity Blue','Portofino Red','Volcano Red','Ventura Orange','Nebula Purple','Dark Storm','Onyx Eclipse','Flame Burnt']:['Phantom Black','Ghost Silver','Forza Grey','Heritage Green','Riviera Navy','Portofino Red','Volcano Red','Ventura Orange','Spectre Gold','Spyder Grey']);
      const rank=link=>{const index=approvedOrder.indexOf(link.title);return index<0?approvedOrder.length:index;};
      const swatches=$$('.swatch').sort((a,b)=>rank(a)-rank(b));
      swatches.forEach(link=>$('.swatches').append(link));
      swatches.forEach(link=>link.style.setProperty('--swatch',colours[link.getAttribute('title')]||'#777'));
      if ($('[data-colour-count]')) $('[data-colour-count]').textContent=this.dataset.colourLabel.replace('[count]',swatches.length);
      const colourRail=$('.swatches'),colourNavigation=$('.swatch-navigation'),colourBack=$('.swatch-back'),colourForward=$('.swatch-forward');
      if(colourRail&&colourBack&&colourForward){
        const syncColourArrows=()=>{
          const maximum=colourRail.scrollWidth-colourRail.clientWidth;
          const position=Math.abs(colourRail.scrollLeft);
          const focused=document.activeElement;
          [[colourBack,position<=2],[colourForward,position>=maximum-2]].forEach(([button,unavailable])=>{
            button.disabled=unavailable;
            button.classList.toggle('is-unavailable',unavailable);
          });
          if((focused===colourBack||focused===colourForward)&&(focused.disabled||focused.hidden)){
            const available=[colourBack,colourForward].find(button=>!button.disabled&&!button.hidden);
            (available||$('.swatch[aria-current="page"]')||swatches[0])?.focus({preventScroll:true});
          }
        };
        const sizeColourNavigation=()=>{
          const style=getComputedStyle(colourRail);
          const contentWidth=swatches.reduce((width,swatch)=>width+swatch.getBoundingClientRect().width,0)+Math.max(0,swatches.length-1)*(parseFloat(style.columnGap)||0)+(parseFloat(style.paddingLeft)||0)+(parseFloat(style.paddingRight)||0);
          const overflows=contentWidth>colourNavigation.clientWidth+2;
          colourBack.hidden=!overflows;
          colourForward.hidden=!overflows;
          syncColourArrows();
        };
        const scrollColours=direction=>{
          const sign=getComputedStyle(colourRail).direction==='rtl'?-1:1;
          colourRail.scrollBy({left:direction*sign*colourRail.clientWidth*.8,behavior});
        };
        colourBack.addEventListener('click',()=>scrollColours(-1),options);
        colourForward.addEventListener('click',()=>scrollColours(1),options);
        colourRail.addEventListener('scroll',syncColourArrows,{...options,passive:true});
        this.colourObserver=new ResizeObserver(sizeColourNavigation);
        this.colourObserver.observe(colourNavigation);
        requestAnimationFrame(()=>{
          sizeColourNavigation();
          const selected=$('.swatch[aria-current="page"]');
          colourRail.scrollLeft=0;
          if(selected&&!aluminiumWallet&&!carbonOrder){
            const delta=selected.getBoundingClientRect().right-colourRail.getBoundingClientRect().right;
            if(delta>0)colourRail.scrollLeft=delta+4;
          }
          syncColourArrows();
        });
      }
      $('.swatches')?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();const i=swatches.indexOf(document.activeElement);
        const n=event.key==='Home'?0:event.key==='End'?swatches.length-1:(i+(event.key==='ArrowRight'?1:-1)+swatches.length)%swatches.length;
        swatches[n].focus();
      },options);

      const focusEngraving=()=>{
        if(!input)return;
        const target=inputs.find(field=>!field.validity.valid)||input;
        target.closest('details').open=true;
        target.scrollIntoView({behavior,block:'center'});target.focus({preventScroll:true});
      };
      const syncText=()=>{
        previews.forEach(preview=>{const field=inputs.find(field=>field.name===preview.dataset.nanoTextPreview);preview.textContent=field?.value.trim()?field.value:emptyPreviews.get(preview);});
        updateSticky();
      };
      inputs.forEach(field=>field.addEventListener('input',syncText,options));
      confirm?.addEventListener('change',()=>updateSticky(),options);
      form?.addEventListener('invalid',event=>{const details=event.target.closest('details');if(details)details.open=true;},{...options,capture:true});
      form?.addEventListener('submit',event=>{
        if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
      },{...options,capture:true});
      $('[data-nano-variant]')?.addEventListener('change',event=>{
        const next=new URL(location.href);next.searchParams.set('variant',event.target.value);const quantity=form?.querySelector('[name="quantity"]');if(quantity?.validity.valid)next.searchParams.set('quantity',quantity.value);location.assign(next);
      },options);
      const updateSticky=()=>{
        if(!mainButton||!sticky)return;
        const rect=mainButton.getBoundingClientRect();
        const before=rect.top>innerHeight;
        const activeField=document.activeElement;
        const focusInField=activeField?.matches('textarea, select, input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"])');
        const galleryPassed=$('.gallery-stage').getBoundingClientRect().top<0;
        const footerVisible=this.closest('.nano-draft2').querySelector('footer').getBoundingClientRect().top<innerHeight;
        const show=rect.bottom<0||(matchMedia('(max-width:700px)').matches&&before&&galleryPassed);
        sticky.hidden=!show||focusInField||zoom.open||footerVisible;
        sticky.classList.toggle('is-before',before);
        stickyButton.disabled=mainButton.disabled;
        stickyButton.firstElementChild.textContent=mainButton.disabled?mainButton.firstElementChild.textContent:before?sticky.dataset.chooseLabel:input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)?sticky.dataset.personaliseLabel:sticky.dataset.addLabel;
      };
      stickyButton?.addEventListener('click',()=>{
        if(mainButton.disabled)return;
        if(sticky.classList.contains('is-before')){$('.purchase-options').scrollIntoView({behavior,block:'center'});return;}
        if(input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)){focusEngraving();form.reportValidity();return;}
        form.requestSubmit(mainButton);
      },options);
      addEventListener('scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(updateSticky);},{...options,passive:true});
      addEventListener('resize',updateSticky,options);
      document.addEventListener('focusin',updateSticky,options);
      document.addEventListener('focusout',()=>requestAnimationFrame(updateSticky),options);
      this.buttonObserver=new MutationObserver(updateSticky);if(mainButton)this.buttonObserver.observe(mainButton,{attributes:true,attributeFilter:['disabled']});
      $$('.products-section').forEach(section=>{
        const row=section.querySelector('.product-row');
        section.querySelector('.row-next')?.addEventListener('click',()=>row.scrollBy({left:row.clientWidth*.8,behavior}),options);
        section.querySelector('.row-prev')?.addEventListener('click',()=>row.scrollBy({left:-row.clientWidth*.8,behavior}),options);
        row?.addEventListener('scroll',()=>section.querySelector('.row-controls').classList.toggle('can-go-back',row.scrollLeft>10),{...options,passive:true});
      });
      const wrapper=this.closest('.nano-draft2');
      const pendingKey='nano-product-engraving-transfer';
      try {
        const pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');
        sessionStorage.removeItem(pendingKey);
        if(input&&pending?.path===location.pathname){
          inputs.forEach((field,index)=>{const value=pending.fields?.[field.name]??(index===0?pending.text:null);if(typeof value==='string'){field.value=value;field.dispatchEvent(new Event('input',{bubbles:true}));}});confirm.checked=false;
        }
      } catch {}
      $$('[data-product-choice]').forEach(link=>link.addEventListener('click',()=>{
        try {
          sessionStorage.removeItem(pendingKey);
          const next=new URL(link.href,location.href);
          if(inputs.some(field=>field.value)&&next.pathname.includes('personalised'))sessionStorage.setItem(pendingKey,JSON.stringify({path:next.pathname,fields:Object.fromEntries(inputs.map(field=>[field.name,field.value]))}));
        } catch {}
      },options));
      wrapper?.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',()=>{
        const target=document.getElementById(link.getAttribute('href').slice(1));
        if(target?.tagName==='DETAILS')target.open=true;
        if(target?.closest('details'))target.closest('details').open=true;
        if(link.hash==='#nano-engraving')requestAnimationFrame(focusEngraving);
      },options));
      const menu=wrapper?.querySelector('#mobile-menu'), toggle=wrapper?.querySelector('.menu-toggle');
      toggle?.addEventListener('click',()=>{menu.hidden=!menu.hidden;toggle.setAttribute('aria-expanded',String(!menu.hidden));},options);
      menu?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.hidden=true;toggle.setAttribute('aria-expanded','false');},options));
      document.querySelector('cart-drawer-component')?.setAttribute('auto-open','');
      wrapper?.querySelector('[data-nano-bag]')?.addEventListener('click',()=>document.querySelector('#cart-drawer')?.open(),options);
      const hash=()=>{if(location.hash==='#nano-engraving')focusEngraving();};
      addEventListener('hashchange',hash,options);
      requestAnimationFrame(()=>{if(input)syncText();setGallery(0,false);updateSticky();hash();});
    }
    disconnectedCallback(){this.controller?.abort();this.buttonObserver?.disconnect();this.galleryObserver?.disconnect();this.colourObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);cancelAnimationFrame(this.galleryFrame);}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-header"]) return;
  try {
    
class NanoNavigation extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const button = this.querySelector('.menu-toggle');
    const menu = this.querySelector('#mobile-menu');
    if (!button || !menu) return;
    const close = (focus = false) => {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', this.dataset.openLabel);
      if (focus) button.focus();
    };
    button.addEventListener('click', () => {
      if (!menu.hidden) return close();
      menu.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', this.dataset.closeLabel);
    }, options);
    menu.addEventListener('click', event => { if (event.target.closest('a')) close(); }, options);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !menu.hidden) close(true); }, options);
    document.addEventListener('click', event => { if (!menu.hidden && !this.contains(event.target)) close(); }, options);
    matchMedia('(max-width: 700px)').addEventListener('change', () => close(), options);
  }
  disconnectedCallback() { this.controller?.abort(); }
}

class NanoWalletChooser extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const choices = [...this.querySelectorAll('.wallet-choice')];
    const image = this.querySelector('#discovery-image');
    const caption = this.querySelector('#discovery-caption');
    if (!image || !caption) return;
    choices.forEach(choice => choice.addEventListener('toggle', () => {
      if (!choice.open) return;
      choices.forEach(other => { if (other !== choice) other.open = false; });
      if (choice.dataset.srcset) image.srcset = choice.dataset.srcset;
      else image.removeAttribute('srcset');
      image.src = choice.dataset.image;
      image.alt = choice.dataset.alt;
      image.dataset.kind = choice.dataset.wallet;
      caption.textContent = choice.dataset.caption;
    }, { signal: this.controller.signal }));
  }
  disconnectedCallback() { this.controller?.abort(); }
}

class NanoFooter extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const mobile = matchMedia('(max-width: 700px)');
    const columns = [...this.querySelectorAll('.footer-column')];
    const layout = () => columns.forEach(column => {
      column.open = !mobile.matches;
      const summary = column.querySelector('summary');
      summary.tabIndex = mobile.matches ? 0 : -1;
      if (mobile.matches) summary.removeAttribute('aria-disabled');
      else summary.setAttribute('aria-disabled', 'true');
    });
    layout();
    mobile.addEventListener('change', layout, options);
    columns.forEach(column => column.addEventListener('toggle', () => { if (!mobile.matches) column.open = true; }, options));
  }
  disconnectedCallback() { this.controller?.abort(); }
}

class NanoMaterialGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const gallery = this.querySelector('#material-gallery');
    const controls = this.querySelector('.material-controls');
    if (!gallery || !controls) return;
    const cards = [...gallery.querySelectorAll('.material-card')];
    if (!cards.length) return;
    const previous = controls.querySelector('[data-material-direction="previous"]');
    const next = controls.querySelector('[data-material-direction="next"]');
    const position = controls.querySelector('.material-position');
    const status = controls.querySelector('.material-status');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const pad = number => String(number).padStart(2, '0');
    const maximum = () => Math.max(0, gallery.scrollWidth - gallery.clientWidth);
    const geometry = () => {
      const viewport = gallery.getBoundingClientRect();
      return cards.map(card => {
        const rect = card.getBoundingClientRect();
        return { left: rect.left - viewport.left, right: rect.right - viewport.left };
      });
    };
    const sync = () => {
      this.frame = 0;
      previous.setAttribute('aria-disabled', String(gallery.scrollLeft <= 2));
      next.setAttribute('aria-disabled', String(gallery.scrollLeft >= maximum() - 2));
      const sizes = geometry();
      let visible = sizes.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.left >= -2 && rect.right <= gallery.clientWidth + 2);
      if (!visible.length) {
        visible = sizes.map((rect, index) => ({ rect, index, area: Math.max(0, Math.min(rect.right, gallery.clientWidth) - Math.max(rect.left, 0)) })).sort((a,b) => b.area-a.area).slice(0,1);
      }
      const first = visible[0].index + 1;
      const last = visible[visible.length-1].index + 1;
      position.textContent = `${pad(first)} — ${pad(last)} / ${pad(cards.length)}`;
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        const template = first === last ? this.dataset.singleLabel : this.dataset.rangeLabel;
        status.textContent = template.replace('[first]', first).replace('[last]', last).replace('[total]', cards.length);
      }, 180);
    };
    const queue = () => { if (!this.frame) this.frame = requestAnimationFrame(sync); };
    const moveTo = (index, immediate = false) => {
      const target = Math.max(0, Math.min(cards.length-1, index));
      const left = geometry()[target].left + gallery.scrollLeft;
      gallery.scrollTo({ left: Math.max(0, Math.min(maximum(), left)), behavior: immediate || reduced.matches ? 'auto' : 'smooth' });
    };
    const moveBy = direction => {
      const sizes = geometry();
      const current = sizes.reduce((best, rect, index) => Math.abs(rect.left) < Math.abs(sizes[best].left) ? index : best, 0);
      moveTo(current + direction);
    };
    previous.addEventListener('click', () => { if (previous.getAttribute('aria-disabled') !== 'true') moveBy(-1); }, options);
    next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') !== 'true') moveBy(1); }, options);
    gallery.addEventListener('scroll', queue, { ...options, passive:true });
    gallery.addEventListener('keydown', event => {
      if (event.target !== gallery || event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') moveTo(0);
      else if (event.key === 'End') moveTo(cards.length-1);
      else moveBy(event.key === 'ArrowRight' ? 1 : -1);
    }, options);
    gallery.addEventListener('focusin', event => {
      const index = cards.indexOf(event.target.closest('.material-card'));
      if (index < 0) return;
      const rect = geometry()[index];
      if (rect.left < -2 || rect.right > gallery.clientWidth + 2) moveTo(index, true);
    }, options);
    this.observer = new ResizeObserver(queue);
    this.observer.observe(gallery);
    controls.hidden = false;
    sync();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    clearTimeout(this.announceTimer);
    cancelAnimationFrame(this.frame);
  }
}

for (const [name, component] of [['nano-navigation',NanoNavigation],['nano-wallet-chooser',NanoWalletChooser],['nano-footer',NanoFooter],['nano-material-gallery',NanoMaterialGallery]]) {
  if (!customElements.get(name)) customElements.define(name, component);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-id-guide"]) return;
  try {
    
  if (!customElements.get('nano-id-gallery')) {
    customElements.define('nano-id-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[data-nid-panel]')];
        const select = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
            panels[i].setAttribute('role', 'tabpanel');
            panels[i].setAttribute('aria-labelledby', tab.id);
            panels[i].tabIndex = 0;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); select(next, true); }
          });
        });
        select(0);
        this.querySelector('[role="tablist"]').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-instructions-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nano-fitting-guide')) {
    customElements.define('nano-fitting-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-target]');
          if (!link || !this.contains(link)) return;
          event.preventDefault();
          const key = link.dataset.target;
          history.pushState(null, '', '#fit-' + key);
          this.selectGuide(key, true);
        }, options);
        this.addEventListener('change', event => {
          if (event.target.matches('[data-current-chooser] input')) this.updateRemoval();
        }, options);
        this.addEventListener('toggle', event => {
          if (event.target.matches('[data-guide]') && event.target.open) this.selectGuide(event.target.dataset.guide, false);
          if (event.target.matches('[data-tray-usage]')) this.updateUsagePhoto();
        }, { ...options, capture: true });
        this.onLocation = () => {
          const key = location.hash.replace('#fit-', '');
          if (this.querySelector('[data-guide="' + CSS.escape(key) + '"]')) this.selectGuide(key, true);
          else this.resetGuides();
        };
        window.addEventListener('hashchange', this.onLocation, options);
        window.addEventListener('popstate', this.onLocation, options);
        document.addEventListener('shopify:block:select', event => {
          const guide = event.target.closest('[data-guide]');
          if (guide && this.contains(guide)) this.selectGuide(guide.dataset.guide, true);
        }, options);
        this.onLocation();
        this.updateUsagePhoto();
      }
      updateUsagePhoto() {
        const everydayPhoto = this.querySelector('[data-everyday-photo]');
        const trayPhoto = this.querySelector('[data-tray-photo]');
        if (!everydayPhoto || !trayPhoto) return;
        const showTray = Boolean(this.querySelector('[data-tray-usage]')?.open);
        everydayPhoto.hidden = showTray;
        trayPhoto.hidden = !showTray;
      }
      disconnectedCallback() { this.controller?.abort(); }
      selectGuide(key, scroll) {
        const guide = Array.from(this.querySelectorAll('[data-guide]')).find(item => item.dataset.guide === key);
        if (!guide) return;
        this.querySelector('[data-current-chooser]').hidden = false;
        this.querySelectorAll('[data-guide]').forEach(item => {
          item.hidden = item !== guide;
          item.open = item === guide;
        });
        this.querySelectorAll('[data-target]').forEach(link => link.setAttribute('aria-current', String(link.dataset.target === key)));
        this.querySelector('[data-guide-status]').textContent = this.dataset.statusLabel + ' ' + guide.dataset.title;
        this.updateRemoval();
        if (scroll) this.querySelector('[data-current-chooser]').scrollIntoView({ behavior: 'auto', block: 'start' });
      }
      resetGuides() {
        this.querySelector('[data-current-chooser]').hidden = true;
        this.querySelector('[data-guide-status]').textContent = '';
        this.querySelectorAll('[data-target]').forEach(link => link.removeAttribute('aria-current'));
        this.querySelectorAll('[data-guide]').forEach(item => { item.hidden = false; item.open = false; });
      }
      updateRemoval() {
        const current = this.querySelector('[data-current-chooser] input:checked')?.value;
        this.querySelectorAll('[data-removal-step]').forEach(step => { step.hidden = current === 'none'; });
        this.querySelectorAll('[data-current-prompt]').forEach(item => { item.hidden = Boolean(current); });
        this.querySelectorAll('[data-removal]').forEach(item => { item.hidden = item.dataset.removal !== current; });
        this.querySelectorAll('[data-guide]').forEach(guide => {
          let number = current === 'none' ? 2 : 3;
          guide.querySelectorAll('[data-step-number]').forEach(item => { item.textContent = String(number++).padStart(2, '0'); });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-key-case-hero-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nano-hero-cutout')) {
  customElements.define('nano-hero-cutout', class extends HTMLElement {
    connectedCallback() {
      const image = this.querySelector('img');
      if (!image || this.dataset.processed) return;
      this.dataset.processed = 'pending';
      const prepare = () => {
        try {
          const scale = Math.min(1, 2000 / Math.max(image.naturalWidth, image.naturalHeight));
          const width = Math.max(1, Math.round(image.naturalWidth * scale));
          const height = Math.max(1, Math.round(image.naturalHeight * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d', { willReadFrequently:true });
          context.drawImage(image, 0, 0, width, height);
          const pixels = context.getImageData(0, 0, width, height);
          const data = pixels.data;
          const normalise = () => {
            const figure = this.closest('.collection-hero-art--front');
            if (!figure) return;
            let left = width, right = -1, top = height, bottom = -1;
            for (let p = 0; p < width * height; p++) {
              if (data[p * 4 + 3] < 16) continue;
              const x = p % width, y = Math.floor(p / width);
              left = Math.min(left, x); right = Math.max(right, x);
              top = Math.min(top, y); bottom = Math.max(bottom, y);
            }
            if (right < left || bottom < top) return;
            figure.style.setProperty('--hero-source-width', (right - left + 1) / width);
            figure.style.setProperty('--hero-subject-ratio', (bottom - top + 1) / (right - left + 1));
            figure.style.setProperty('--hero-source-x', `${-(left + right + 1) / width * 50}%`);
            figure.style.setProperty('--hero-source-y', `${-(top + bottom + 1) / height * 50}%`);
            figure.style.setProperty('--hero-source-top', `${-top / height * 100}%`);
          };
          if (this.hasAttribute('data-measure-only')) {
            normalise();
            this.dataset.processed = 'original';
            return;
          }
          const corners = [0, width - 1, (height - 1) * width, width * height - 1];
          const backgrounds = corners.filter(p => {
            const i = p * 4;
            return data[i + 3] > 240 && Math.min(data[i], data[i + 1], data[i + 2]) > 220 && Math.max(data[i], data[i + 1], data[i + 2]) - Math.min(data[i], data[i + 1], data[i + 2]) < 25;
          }).map(p => Array.from(data.slice(p * 4, p * 4 + 3)));
          if (!backgrounds.length) { normalise(); this.dataset.processed = 'original'; return; }
          const seen = new Uint8Array(width * height);
          const queue = new Int32Array(width * height);
          let head = 0;
          let tail = 0;
          const visit = p => {
            if (seen[p]) return;
            seen[p] = 1;
            const i = p * 4;
            if (data[i + 3] < 16 || backgrounds.some(bg => Math.max(Math.abs(data[i] - bg[0]), Math.abs(data[i + 1] - bg[1]), Math.abs(data[i + 2] - bg[2])) < 26)) {
              data[i + 3] = 0;
              queue[tail++] = p;
            }
          };
          for (let x = 0; x < width; x++) { visit(x); visit((height - 1) * width + x); }
          for (let y = 0; y < height; y++) { visit(y * width); visit(y * width + width - 1); }
          while (head < tail) {
            const p = queue[head++];
            const x = p % width;
            if (x > 0) visit(p - 1);
            if (x < width - 1) visit(p + 1);
            if (p >= width) visit(p - width);
            if (p < width * (height - 1)) visit(p + width);
          }
          if (this.hasAttribute('data-clear-openings')) {
            const collect = p => {
              if (seen[p]) return;
              seen[p] = 1;
              const i = p * 4;
              if (backgrounds.some(bg => Math.max(Math.abs(data[i] - bg[0]), Math.abs(data[i + 1] - bg[1]), Math.abs(data[i + 2] - bg[2])) < 26)) queue[tail++] = p;
            };
            for (let start = 0; start < width * height; start++) {
              if (seen[start]) continue;
              head = 0;
              tail = 0;
              collect(start);
              while (head < tail) {
                const p = queue[head++];
                const x = p % width;
                if (x > 0) collect(p - 1);
                if (x < width - 1) collect(p + 1);
                if (p >= width) collect(p - width);
                if (p < width * (height - 1)) collect(p + width);
              }
              if (tail > width * height * 0.001) {
                for (let i = 0; i < tail; i++) data[queue[i] * 4 + 3] = 0;
              }
            }
          }
          const distance = new Uint16Array(width * height);
          const inset = Math.max(1, Math.ceil(Math.max(width, height) / 700));
          for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
              const p = y * width + x;
              if (!data[p * 4 + 3]) continue;
              let nearest = 65534;
              if (x > 0) nearest = Math.min(nearest, distance[p - 1]);
              if (y > 0) {
                nearest = Math.min(nearest, distance[p - width]);
                if (x > 0) nearest = Math.min(nearest, distance[p - width - 1]);
                if (x < width - 1) nearest = Math.min(nearest, distance[p - width + 1]);
              }
              distance[p] = nearest + 1;
            }
          }
          for (let y = height - 1; y >= 0; y--) {
            for (let x = width - 1; x >= 0; x--) {
              const p = y * width + x;
              if (!distance[p]) continue;
              let nearest = 65534;
              if (x < width - 1) nearest = Math.min(nearest, distance[p + 1]);
              if (y < height - 1) {
                nearest = Math.min(nearest, distance[p + width]);
                if (x > 0) nearest = Math.min(nearest, distance[p + width - 1]);
                if (x < width - 1) nearest = Math.min(nearest, distance[p + width + 1]);
              }
              distance[p] = Math.min(distance[p], nearest + 1);
            }
          }
          for (let p = 0; p < distance.length; p++) {
            const i = p * 4;
            data[i] = 255;
            data[i + 1] = 255;
            data[i + 2] = 255;
            if (distance[p] <= inset) data[i + 3] = 0;
          }
          context.putImageData(pixels, 0, 0);
          image.style.maskImage = `url("${canvas.toDataURL('image/png')}")`;
          image.style.maskSize = 'contain';
          image.style.maskPosition = 'center';
          image.style.maskRepeat = 'no-repeat';
          normalise();
          this.dataset.processed = 'ready';
        } catch {
          this.dataset.processed = 'unavailable';
        }
      };
      if (image.complete && image.naturalWidth) prepare();
      else image.addEventListener('load', prepare, { once:true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-offer-popup"]) return;
  try {
    
class NanoWelcomeOffer extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.startedAt = Date.now();
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('form');
    this.intro = this.querySelector('[data-offer-intro]');
    this.success = this.querySelector('[data-offer-success]');
    this.editor = this.dataset.editor === 'true';
    const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, {...options, signal: this.controller.signal});
    this.querySelectorAll('[data-offer-close]').forEach(button => on(button, 'click', () => this.dialog.close()));
    this.querySelectorAll('[data-offer-open]').forEach(button => on(button, 'click', () => this.show(false, true)));
    on(this.dialog, 'close', () => {
      document.body.classList.remove('nano-welcome-open');
      if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll: true});
    });
    on(this.dialog, 'click', event => {
      if (event.target !== this.dialog) return;
      const box = this.dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
    });
    on(this.form, 'submit', event => {
      if (this.editor) {
        event.preventDefault();
        this.show(true, true);
        return;
      }
      if (!this.form.checkValidity()) return;
      this.write('sessionStorage', 'nano_offer_pending_v1', String(Date.now()));
      this.form.setAttribute('aria-busy', 'true');
    });
    on(this.querySelector('[data-offer-copy]'), 'click', async () => {
      const status = this.querySelector('.nano-welcome__status');
      try {
        await navigator.clipboard.writeText(this.querySelector('[data-offer-code]').textContent.trim());
        status.textContent = this.dataset.copySuccess;
      } catch {
        status.textContent = this.dataset.copyFailure;
      }
    });
    const pendingAt = Number(this.read('sessionStorage', 'nano_offer_pending_v1'));
    const pending = pendingAt > 0 && Date.now() - pendingAt < 1800000;
    const returnedToForm = location.hash === '#' + this.form.id;
    const result = this.querySelector('[data-offer-result]')?.dataset.offerResult;
    if ((pending || returnedToForm) && result === 'success') {
      this.write('localStorage', 'nano_offer_subscribed_v1', 'true');
      this.write('sessionStorage', 'nano_offer_subscribed_v1', 'true');
      this.remove('sessionStorage', 'nano_offer_pending_v1');
      this.show(true, true);
      return;
    }
    if ((pending || returnedToForm) && result === 'error') {
      this.remove('sessionStorage', 'nano_offer_pending_v1');
      this.show(false, true);
      return;
    }
    if (this.editor || this.suppressed()) return;
    on(document, 'mouseout', event => {
      if (!this.mobile() && !event.relatedTarget && event.clientY <= 0 && Date.now() - this.startedAt >= Number(this.dataset.desktopDelay) * 1000) this.show();
    });
    const mobileCheck = () => {
      clearTimeout(this.mobileTimer);
      if (!this.mobile() || this.suppressed()) return;
      const remaining = Number(this.dataset.mobileDelay) * 1000 - (Date.now() - this.startedAt);
      if (remaining > 0) {
        this.mobileTimer = setTimeout(mobileCheck, remaining);
        return;
      }
      const distance = document.documentElement.scrollHeight - innerHeight;
      const progress = distance > 0 ? scrollY / distance * 100 : 0;
      if (progress >= Number(this.dataset.mobileScroll)) this.show();
    };
    on(window, 'scroll', mobileCheck, {passive: true});
    on(window, 'resize', mobileCheck, {passive: true});
    on(document, 'visibilitychange', mobileCheck);
    mobileCheck();
  }
  read(storage, key) {
    try { return window[storage].getItem(key); } catch { return null; }
  }
  write(storage, key, value) {
    try { window[storage].setItem(key, value); } catch {}
  }
  remove(storage, key) {
    try { window[storage].removeItem(key); } catch {}
  }
  mobile() {
    return matchMedia('(pointer: coarse), (max-width: 680px)').matches;
  }
  suppressed() {
    const lastShown = Math.max(Number(this.read('localStorage', 'nano_offer_shown_v1')) || 0, Number(this.read('sessionStorage', 'nano_offer_shown_v1')) || 0);
    return this.shown || this.dataset.subscriber === 'true' || this.read('localStorage', 'nano_offer_subscribed_v1') === 'true' || this.read('sessionStorage', 'nano_offer_subscribed_v1') === 'true' || (lastShown > 0 && Date.now() - lastShown < Number(this.dataset.cooldownDays) * 86400000);
  }
  blocked() {
    if (document.hidden || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
    if (document.querySelector('dialog[open], .nn-category[open]')) return true;
    if (matchMedia('(max-width: 900px)').matches && document.querySelector('.nn-shell[open]')) return true;
    return [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  }
  show(success = false, forced = false) {
    if (!forced && (this.suppressed() || this.blocked())) return;
    this.previousFocus = document.activeElement;
    this.intro.hidden = success;
    this.success.hidden = !success;
    const view = success ? this.success : this.intro;
    const heading = view.querySelector('h2');
    this.dialog.setAttribute('aria-labelledby', heading.id);
    this.dialog.setAttribute('aria-describedby', view.querySelector('.nano-welcome__description').id);
    if (!this.dialog.open) this.dialog.showModal();
    document.body.classList.add('nano-welcome-open');
    heading.focus({preventScroll: true});
    this.shown = true;
    clearTimeout(this.mobileTimer);
    if (!this.editor) {
      this.write('localStorage', 'nano_offer_shown_v1', String(Date.now()));
      this.write('sessionStorage', 'nano_offer_shown_v1', String(Date.now()));
    }
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    clearTimeout(this.mobileTimer);
    if (this.dialog?.open) this.dialog.close();
    document.body.classList.remove('nano-welcome-open');
  }
}
if (!customElements.get('nano-welcome-offer')) customElements.define('nano-welcome-offer', NanoWelcomeOffer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-offer-preview"]) return;
  try {
    
class NanoOfferPreview extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const dialog = this.querySelector('dialog');
    const intro = this.querySelector('[data-offer-intro]');
    const success = this.querySelector('[data-offer-success]');
    const openButton = this.querySelector('[data-offer-open]');
    const heading = intro.querySelector('h2');
    const description = intro.querySelector('.nano-offer__description');
    const show = () => {
      intro.hidden = false;
      this.querySelector('.nano-offer__status').textContent = '';
      success.hidden = true;
      dialog.setAttribute('aria-labelledby', heading.id);
      dialog.setAttribute('aria-describedby', description.id);
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('nano-offer-open');
      heading.focus({preventScroll:true});
    };
    openButton.addEventListener('click', show);
    this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('close', () => {
      document.body.classList.remove('nano-offer-open');
      openButton.focus({preventScroll:true});
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    this.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      event.stopPropagation();
      intro.hidden = true;
      success.hidden = false;
      const successHeading = success.querySelector('h2');
      successHeading.id = heading.id + '-success';
      dialog.setAttribute('aria-labelledby', successHeading.id);
      dialog.removeAttribute('aria-describedby');
      this.querySelector('form').reset();
      successHeading.focus({preventScroll:true});
    });
    this.querySelector('[data-offer-copy]').addEventListener('click', async () => {
      const status = this.querySelector('.nano-offer__status');
      try {
        await navigator.clipboard.writeText(this.querySelector('[data-offer-code]').textContent.trim());
        status.textContent = this.dataset.copySuccess;
      } catch {
        status.textContent = this.dataset.copyFailure;
      }
    });
    requestAnimationFrame(show);
  }
  disconnectedCallback() {
    document.body.classList.remove('nano-offer-open');
  }
}
if (!customElements.get('nano-offer-preview')) customElements.define('nano-offer-preview', NanoOfferPreview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-product-main"]) return;
  try {
    
if (!customElements.get('nano-product-draft2')) {
  customElements.define('nano-product-draft2', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const $ = selector => this.querySelector(selector);
      const $$ = selector => [...this.querySelectorAll(selector)];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduced ? 'instant' : 'smooth';
      const form = $('product-form-component form');
      const inputs = $$('[data-nano-engraving-input]');
      const input = inputs[0];
      const confirm = $('[data-nano-engraving-confirm]');
      const previews = $$('[data-nano-text-preview]');
      const emptyPreviews = new Map(previews.map(preview => [preview, preview.textContent]));
      const mainButton = $('.add-to-bag');
      const sticky = $('.sticky-purchase');
      const stickyButton = $('.sticky-button');
      const track = $('.gallery-track');
      const thumbs = $$('.gallery-thumb');
      const slides = $$('.gallery-slide');
      const zoom = $('#zoom-dialog');
      const gallery = $('.gallery');
      const sizeGallery = () => gallery?.style.setProperty('--nano-gallery-top',`${Math.min(24,innerHeight-gallery.getBoundingClientRect().height-24)}px`);
      this.galleryObserver?.disconnect();
      this.galleryObserver = new ResizeObserver(sizeGallery);
      if(gallery)this.galleryObserver.observe(gallery);
      addEventListener('resize',sizeGallery,options);
      let frame = 0;
      const setGallery = (next, scroll=true) => {
        if (!slides.length) return;
        frame = (next+slides.length)%slides.length;
        thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed',String(i===frame)));
        $('.gallery-count').textContent = `${String(frame+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
        $('.gallery-caption').textContent=slides[frame].dataset.caption||slides[frame].getAttribute('aria-label');
        if (scroll) track.scrollTo({left:frame*track.clientWidth,behavior});
        if (zoom.open) {
          const photo=slides[frame].querySelector('img');
          $('.zoom-image-container img').src=thumbs[frame].dataset.large;
          $('.zoom-image-container img').alt=photo.alt;
          $('.zoom-image-container img').className=photo.className;
          $('.zoom-image-container img').style.setProperty('--nano-image-mask',photo.style.getPropertyValue('--nano-image-mask'));
          $('.zoom-caption').textContent=`${$('.gallery-caption').textContent} · ${$('.gallery-count').textContent}`;
          $('.zoom-image-container').classList.remove('is-magnified');
        }
      };
      this.addEventListener('nano:mask-ready',()=>{if(zoom.open)setGallery(frame,false);},options);
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>setGallery(i),options));
      $('.gallery-previous')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.gallery-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      track?.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.galleryFrame);
        this.galleryFrame=requestAnimationFrame(()=>setGallery(Math.round(track.scrollLeft/track.clientWidth),false));
      },{...options,passive:true});
      track?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();setGallery(event.key==='Home'?0:event.key==='End'?slides.length-1:frame+(event.key==='ArrowRight'?1:-1));
      },options);
      $('.zoom-open')?.addEventListener('click',()=>{zoom.showModal();setGallery(frame,false);},options);
      $('.zoom-prev')?.addEventListener('click',()=>setGallery(frame-1),options);
      $('.zoom-next')?.addEventListener('click',()=>setGallery(frame+1),options);
      $('.zoom-image-container')?.addEventListener('click',()=>$('.zoom-image-container').classList.toggle('is-magnified'),options);
      zoom?.querySelector('.close-dialog')?.addEventListener('click',()=>zoom.close(),options);
      zoom?.addEventListener('click',event=>{if(event.target===zoom)zoom.close();},options);
      zoom?.addEventListener('keydown',event=>{
        if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();setGallery(frame+(event.key==='ArrowRight'?1:-1));}
      },options);

      const colours={
        'Phantom Black':'#29282b','Ghost Silver':'#d1d2ce','Forza Grey':'#93a3a9','Heritage Green':'#8d9e70','Riviera Navy':'#34485b','Portofino Red':'#b1333b','Volcano Red':'#ce352b','Ventura Orange':'#c77235','Spectre Gold':'#bcab84','Spyder Grey':'#717578','Titan Gunmetal':'#626568','Sonic Copper':'#a56946','Racing Green':'#2e5146','Skyfall Navy':'#293d59','Carrera White':'#eeeae3','Nebula Purple':'#684766','Viper Green':'#8dba41','Dark Storm':'#35393d','Onyx Eclipse':'#222225','Flame Burnt':'linear-gradient(135deg,#385d90,#a9664e,#99783b)','Velocity Blue':'#2d84b8','Stealth Black':'#262626','Nero':'#262626','Nero/Argento':'linear-gradient(135deg,#292929 45%,#b7b6b0 55%)','Nero/Viola':'linear-gradient(135deg,#292929 45%,#73498b 55%)','Nero/Arancione':'linear-gradient(135deg,#292929 45%,#d5752e 55%)','Nero/Rosso':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Nero/Verde':'linear-gradient(135deg,#292929 45%,#49965a 55%)','Nero/Oro':'linear-gradient(135deg,#292929 45%,#b4a05a 55%)','Nero/Azzuro':'linear-gradient(135deg,#292929 45%,#327cb4 55%)','Diablo Red/Stealth Black':'linear-gradient(135deg,#292929 45%,#b6333c 55%)','Ocean Mist':'#bacdd0','Orchard Mint':'#c1ccb6','Sunset Blush':'#d7b3b7','Twilight Lilac':'#b5a7c5'};
      const aluminiumWallet=this.hasAttribute('data-aluminium-wallet');
      const carbonOrder=this.dataset.walletMaterial==='CARBON FIBRE 3K'?["Stealth Black","Diablo Red/Stealth Black","Stealth Black/Nebula Purple","Stealth Black/Ventura Orange","Stealth Black/Volcano Red","Stealth Black/Miami Blue","Stealth Black/Viper Green","Stealth Black/Ghost Silver","Stealth Black/Spectre Gold"]:this.dataset.walletMaterial==='FORGED CARBON'?["Nero","Nero/Argento","Nero/Oro","Nero/Verde","Nero/Azzuro","Nero/Rosso","Nero/Arancione","Nero/Viola"]:null;
      const approvedOrder=carbonOrder||(aluminiumWallet?['Phantom Black','Titan Gunmetal','Forza Grey','Spyder Grey','Ghost Silver','Carrera White','Spectre Gold','Sonic Copper','Racing Green','Heritage Green','Viper Green','Skyfall Navy','Riviera Navy','Velocity Blue','Portofino Red','Volcano Red','Ventura Orange','Nebula Purple','Dark Storm','Onyx Eclipse','Flame Burnt','Cosmic Pulse','Crimson Trace']:['Phantom Black','Ghost Silver','Forza Grey','Heritage Green','Riviera Navy','Portofino Red','Volcano Red','Ventura Orange','Spectre Gold','Spyder Grey']);
      const rank=link=>{const index=approvedOrder.indexOf(link.title);return index<0?approvedOrder.length:index;};
      const swatches=$$('.swatch').sort((a,b)=>rank(a)-rank(b));
      swatches.forEach(link=>$('.swatches').append(link));
      swatches.forEach(link=>link.style.setProperty('--swatch',colours[link.getAttribute('title')]||'#777'));
      if ($('[data-colour-count]')) $('[data-colour-count]').textContent=this.dataset.colourLabel.replace('[count]',swatches.length);
      const colourRail=$('.swatches'),colourNavigation=$('.swatch-navigation'),colourBack=$('.swatch-back'),colourForward=$('.swatch-forward');
      if(colourRail&&colourBack&&colourForward){
        const syncColourArrows=()=>{
          const maximum=colourRail.scrollWidth-colourRail.clientWidth;
          const position=Math.abs(colourRail.scrollLeft);
          const focused=document.activeElement;
          [[colourBack,position<=2],[colourForward,position>=maximum-2]].forEach(([button,unavailable])=>{
            button.disabled=unavailable;
            button.classList.toggle('is-unavailable',unavailable);
          });
          if((focused===colourBack||focused===colourForward)&&(focused.disabled||focused.hidden)){
            const available=[colourBack,colourForward].find(button=>!button.disabled&&!button.hidden);
            (available||$('.swatch[aria-current="page"]')||swatches[0])?.focus({preventScroll:true});
          }
        };
        const sizeColourNavigation=()=>{
          const style=getComputedStyle(colourRail);
          const contentWidth=swatches.reduce((width,swatch)=>width+swatch.getBoundingClientRect().width,0)+Math.max(0,swatches.length-1)*(parseFloat(style.columnGap)||0)+(parseFloat(style.paddingLeft)||0)+(parseFloat(style.paddingRight)||0);
          const overflows=contentWidth>colourNavigation.clientWidth+2;
          colourBack.hidden=!overflows;
          colourForward.hidden=!overflows;
          syncColourArrows();
        };
        const scrollColours=direction=>{
          const sign=getComputedStyle(colourRail).direction==='rtl'?-1:1;
          colourRail.scrollBy({left:direction*sign*colourRail.clientWidth*.8,behavior});
        };
        colourBack.addEventListener('click',()=>scrollColours(-1),options);
        colourForward.addEventListener('click',()=>scrollColours(1),options);
        colourRail.addEventListener('scroll',syncColourArrows,{...options,passive:true});
        this.colourObserver=new ResizeObserver(sizeColourNavigation);
        this.colourObserver.observe(colourNavigation);
        requestAnimationFrame(()=>{
          sizeColourNavigation();
          const selected=$('.swatch[aria-current="page"]');
          colourRail.scrollLeft=0;
          if(selected&&!aluminiumWallet&&!carbonOrder){
            const delta=selected.getBoundingClientRect().right-colourRail.getBoundingClientRect().right;
            if(delta>0)colourRail.scrollLeft=delta+4;
          }
          syncColourArrows();
        });
      }
      $('.swatches')?.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();const i=swatches.indexOf(document.activeElement);
        const n=event.key==='Home'?0:event.key==='End'?swatches.length-1:(i+(event.key==='ArrowRight'?1:-1)+swatches.length)%swatches.length;
        swatches[n].focus();
      },options);

      const focusEngraving=()=>{
        if(!input)return;
        const target=inputs.find(field=>!field.validity.valid)||input;
        target.closest('details').open=true;
        target.scrollIntoView({behavior,block:'center'});target.focus({preventScroll:true});
      };
      const syncText=()=>{
        previews.forEach(preview=>{const field=inputs.find(field=>field.name===preview.dataset.nanoTextPreview);preview.textContent=field?.value.trim()?field.value:emptyPreviews.get(preview);});
        updateSticky();
      };
      inputs.forEach(field=>field.addEventListener('input',syncText,options));
      confirm?.addEventListener('change',()=>updateSticky(),options);
      form?.addEventListener('invalid',event=>{const details=event.target.closest('details');if(details)details.open=true;},{...options,capture:true});
      form?.addEventListener('submit',event=>{
        if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
      },{...options,capture:true});
      $('[data-nano-variant]')?.addEventListener('change',event=>{
        const next=new URL(location.href);next.searchParams.set('variant',event.target.value);const quantity=form?.querySelector('[name="quantity"]');if(quantity?.validity.valid)next.searchParams.set('quantity',quantity.value);location.assign(next);
      },options);
      const updateSticky=()=>{
        if(!mainButton||!sticky)return;
        const rect=mainButton.getBoundingClientRect();
        const before=rect.top>innerHeight;
        const activeField=document.activeElement;
        const focusInField=activeField?.matches('textarea, select, input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"])');
        const galleryPassed=$('.gallery-stage').getBoundingClientRect().top<0;
        const footerVisible=this.closest('.nano-draft2').querySelector('footer').getBoundingClientRect().top<innerHeight;
        const show=rect.bottom<0||(matchMedia('(max-width:700px)').matches&&before&&galleryPassed);
        sticky.hidden=!show||focusInField||zoom.open||footerVisible;
        sticky.classList.toggle('is-before',before);
        stickyButton.disabled=mainButton.disabled;
        stickyButton.firstElementChild.textContent=mainButton.disabled?mainButton.firstElementChild.textContent:before?sticky.dataset.chooseLabel:input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)?sticky.dataset.personaliseLabel:sticky.dataset.addLabel;
      };
      stickyButton?.addEventListener('click',()=>{
        if(mainButton.disabled)return;
        if(sticky.classList.contains('is-before')){$('.purchase-options').scrollIntoView({behavior,block:'center'});return;}
        if(input&&(inputs.some(field=>!field.validity.valid)||!confirm.checked)){focusEngraving();form.reportValidity();return;}
        form.requestSubmit(mainButton);
      },options);
      addEventListener('scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(updateSticky);},{...options,passive:true});
      addEventListener('resize',updateSticky,options);
      document.addEventListener('focusin',updateSticky,options);
      document.addEventListener('focusout',()=>requestAnimationFrame(updateSticky),options);
      this.buttonObserver=new MutationObserver(updateSticky);if(mainButton)this.buttonObserver.observe(mainButton,{attributes:true,attributeFilter:['disabled']});
      $$('.products-section').forEach(section=>{
        const row=section.querySelector('.product-row');
        section.querySelector('.row-next')?.addEventListener('click',()=>row.scrollBy({left:row.clientWidth*.8,behavior}),options);
        section.querySelector('.row-prev')?.addEventListener('click',()=>row.scrollBy({left:-row.clientWidth*.8,behavior}),options);
        row?.addEventListener('scroll',()=>section.querySelector('.row-controls').classList.toggle('can-go-back',row.scrollLeft>10),{...options,passive:true});
      });
      const wrapper=this.closest('.nano-draft2');
      const pendingKey='nano-product-engraving-transfer';
      try {
        const pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');
        sessionStorage.removeItem(pendingKey);
        if(input&&pending?.path===location.pathname){
          inputs.forEach((field,index)=>{const value=pending.fields?.[field.name]??(index===0?pending.text:null);if(typeof value==='string'){field.value=value;field.dispatchEvent(new Event('input',{bubbles:true}));}});confirm.checked=false;
        }
      } catch {}
      $$('[data-product-choice]').forEach(link=>link.addEventListener('click',()=>{
        try {
          sessionStorage.removeItem(pendingKey);
          const next=new URL(link.href,location.href);
          if(inputs.some(field=>field.value)&&next.pathname.includes('personalised'))sessionStorage.setItem(pendingKey,JSON.stringify({path:next.pathname,fields:Object.fromEntries(inputs.map(field=>[field.name,field.value]))}));
        } catch {}
      },options));
      wrapper?.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',()=>{
        const target=document.getElementById(link.getAttribute('href').slice(1));
        if(target?.tagName==='DETAILS')target.open=true;
        if(target?.closest('details'))target.closest('details').open=true;
        if(link.hash==='#nano-engraving')requestAnimationFrame(focusEngraving);
      },options));
      const menu=wrapper?.querySelector('#mobile-menu'), toggle=wrapper?.querySelector('.menu-toggle');
      toggle?.addEventListener('click',()=>{menu.hidden=!menu.hidden;toggle.setAttribute('aria-expanded',String(!menu.hidden));},options);
      menu?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.hidden=true;toggle.setAttribute('aria-expanded','false');},options));
      document.querySelector('cart-drawer-component')?.setAttribute('auto-open','');
      wrapper?.querySelector('[data-nano-bag]')?.addEventListener('click',()=>document.querySelector('#cart-drawer')?.open(),options);
      const hash=()=>{if(location.hash==='#nano-engraving')focusEngraving();};
      addEventListener('hashchange',hash,options);
      requestAnimationFrame(()=>{if(input)syncText();setGallery(0,false);updateSticky();hash();});
    }
    disconnectedCallback(){this.controller?.abort();this.buttonObserver?.disconnect();this.galleryObserver?.disconnect();this.colourObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);cancelAnimationFrame(this.galleryFrame);}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-reviews-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nano-review-stories')) {
  customElements.define('nano-review-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const filters = this.querySelector('.nr-filters');
      const buttons = [...filters.querySelectorAll('button')];
      const cards = [...this.querySelectorAll('[data-review-source]')];
      const count = this.querySelector('.nr-count');
      filters.hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const source = button.dataset.source;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = source !== 'all' && card.dataset.reviewSource !== source; });
        count.textContent = count.dataset.countTemplate.replace('[count]', String(cards.filter(card => !card.hidden).length));
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nano-sale-countdown')) {
    customElements.define('nano-sale-countdown', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.endAt);
        this.ukClock = this.dataset.dailyReset ? new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        }) : null;
        this.timerLabel = this.querySelector('[role="timer"]');
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        this.hero = document.getElementById('collection-title')?.closest('.shopify-section');
        this.saleActive = false;
        this.syncVisibility = () => {
          const pastIntro = this.hero ? this.hero.getBoundingClientRect().bottom <= 0 : window.scrollY >= 160;
          const viewport = window.visualViewport;
          const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
          const visible = this.saleActive && pastIntro && !editing && (!viewport || viewport.scale < 1.05);
          this.dataset.active = String(visible);
          this.inert = !visible;
          this.setAttribute('aria-hidden', String(!visible));
        };
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            this.syncVisibility();
          });
        };
        this.tick = () => {
          if (!this.dataset.endAt && !this.ukClock) {
            this.saleActive = true;
            this.syncVisibility();
            return true;
          }
          let remaining;
          if (this.ukClock) {
            const parts = Object.fromEntries(this.ukClock.formatToParts(new Date()).map(part => [part.type, part.value]));
            const hour = Number(parts.hour);
            if (hour < 6) {
              this.saleActive = false;
              this.syncVisibility();
              return true;
            }
            remaining = 86400 - hour * 3600 - Number(parts.minute) * 60 - Number(parts.second);
          } else {
            remaining = Math.ceil((this.deadline - Date.now()) / 1000);
          }
          if (!Number.isFinite(remaining) || remaining <= 0) {
            this.saleActive = false;
            this.syncVisibility();
            clearInterval(this.interval);
            this.observer?.disconnect();
            return false;
          }
          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const seconds = remaining % 60;
          this.hours.textContent = String(hours).padStart(2, '0');
          this.minutes.textContent = String(minutes).padStart(2, '0');
          this.seconds.textContent = String(seconds).padStart(2, '0');
          this.timerLabel.setAttribute('aria-label', `${hours}h ${minutes}m ${seconds}s`);
          this.saleActive = true;
          this.syncVisibility();
          return true;
        };
        if (!this.tick()) return;
        if (this.dataset.endAt || this.ukClock) this.interval = setInterval(this.tick, 1000);
        this.observer = new ResizeObserver(entries => {
          const height = `${entries[0].target.getBoundingClientRect().height}px`;
          this.style.setProperty('--nano-countdown-height', height);
          this.closest('.nano-draft2')?.style.setProperty('--nano-countdown-offset', height);
          this.onScroll();
        });
        this.observer.observe(this.querySelector('.nano-countdown-bar'));
        this.onVisibility = () => { if (!document.hidden) this.tick(); };
        document.addEventListener('visibilitychange', this.onVisibility);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        window.addEventListener('pageshow', this.onScroll);
        window.visualViewport?.addEventListener('resize', this.onScroll);
        window.visualViewport?.addEventListener('scroll', this.onScroll);
        document.addEventListener('focusin', this.onScroll);
        document.addEventListener('focusout', this.onScroll);
        if (this.hero) {
          this.heroObserver = new ResizeObserver(this.onScroll);
          this.heroObserver.observe(this.hero);
        }
        Promise.all([document.fonts.load('400 24px Inter', '0123456789'), document.fonts.load('500 12px Inter', 'Shop sale')]).then(fonts => {
          if (!this.isConnected) return;
          this.dataset.fontReady = String(fonts.every(faces => faces.length > 0 && faces.every(face => face.status === 'loaded')));
        }).catch(() => { this.dataset.fontReady = 'false'; });
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        this.observer?.disconnect();
        this.heroObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        window.removeEventListener('pageshow', this.onScroll);
        window.visualViewport?.removeEventListener('resize', this.onScroll);
        window.visualViewport?.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('focusin', this.onScroll);
        document.removeEventListener('focusout', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nano-search"]) return;
  try {
    
  class NanoSearch extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const form = this.querySelector('.ns-form');
      const input = form.querySelector('[name=q]');
      if (this.dataset.graffitiSearch === 'true') document.title = 'NANO Graffiti Wallets — NANO™';
const exactQuery = this.dataset.exactQuery;
      const currentUrl = new URL(location.href);
      if (exactQuery && currentUrl.searchParams.get('q') !== exactQuery) {
        currentUrl.searchParams.set('q', exactQuery);
        currentUrl.searchParams.delete('page');
        currentUrl.hash = '';
        location.replace(currentUrl.href);
        return;
      }
      const finishName = input.value.trim().toLowerCase();
      const clear = form.querySelector('[data-clear]');
      const syncClear = () => { clear.hidden = !input.value.length; };
      input.addEventListener('input', syncClear, options);
      clear.addEventListener('click', () => { input.value = ''; syncClear(); input.focus(); }, options);
      form.addEventListener('submit', event => {
        input.value = input.value.trim();
        if (!input.value) { event.preventDefault(); input.focus(); }
        else if (exactQuery && input.value.toLowerCase() === finishName) input.value = exactQuery;
      }, options);
      const paging = this.querySelector('[data-pagination]');
      if (!paging) return;
      const cards = [...this.querySelector('[data-results]').children];
      const mobile = matchMedia('(max-width:700px)');
      const previous = paging.querySelector('[data-page=previous]');
      const next = paging.querySelector('[data-page=next]');
      const offset = Number(paging.dataset.offset);
      const total = Number(paging.dataset.total);
      const update = () => {
        const second = mobile.matches && cards.length > 8 && ['#nano-search-second','#nano-search-last'].includes(location.hash);
        const start = second ? 8 : 0;
        const end = mobile.matches ? Math.min(start + 8,cards.length) : cards.length;
        cards.forEach((card,index) => { card.hidden = index < start || index >= end; });
        paging.hidden = total <= (mobile.matches ? 8 : 16);
        paging.querySelector('[data-page-range]').textContent = paging.dataset.range.replace('[first]',offset+start+1).replace('[last]',offset+end).replace('[count]',total);
        const prevUrl = second ? '#nano-search-first' : paging.dataset.previous && paging.dataset.previous + (mobile.matches ? '#nano-search-last' : '');
        const nextUrl = mobile.matches && !second && cards.length > 8 ? '#nano-search-second' : paging.dataset.next;
        [[previous,prevUrl],[next,nextUrl]].forEach(([link,url]) => {
          link.setAttribute('href',url || '#');
          link.setAttribute('aria-disabled',String(!url));
          if (url) link.removeAttribute('tabindex'); else link.setAttribute('tabindex','-1');
        });
      };
      paging.addEventListener('click', event => {
        const link = event.target.closest('[data-page]');
        if (link?.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, options);
      window.addEventListener('hashchange', () => { update(); this.querySelector('.ns-term')?.focus(); }, options);
      mobile.addEventListener('change',update,options);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('nano-search')) customElements.define('nano-search',NanoSearch);

  } catch(e) { console.error(e); }
})();
})();
